// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T19:55:12.223Z
// Property: River Pointe (ID: 6767906449166902)
// Collections: 22 amenities, 4 floorplans (live), 41 photos, 43 POIs, 1 reviews, 5 virtual tours, 7 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166902",
  "property_external_id": "495825",
  "property_zillow_url": "https://www.zillow.com/apartments/sacramento-ca/american-river-commons/5XjVF8/",
  "property_apartments_url": "https://www.apartments.com/river-pointe-sacramento-ca/6mf0bss/",
  "property_google_business_url": "https://www.google.com/maps/place/River+Pointe+Apartments/data=!4m2!3m1!1s0x0:0x26ac9c1f38338976?sa=X&ved=2ahUKEwif3YbTk7ySAxWVMVkFHQXaDH0Q_BJ6BAgNEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321266756",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495825 p0505493",
  "property_status": null,
  "property_slug": "river-pointe",
  "property_name": "River Pointe",
  "property_website_url": "https://www.apartments-in-sacramento.com/",
  "property_domain": "https://www.apartments-in-sacramento.com/",
  "property_address": "2361 Oak Harbour Drive",
  "property_full_address": "2361 Oak Harbour Dr, Sacramento, CA 95833",
  "property_address_1": "2361 Oak Harbour Drive",
  "property_address_2": null,
  "property_address_city": "Sacramento",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "95833",
  "property_address_country": "US",
  "property_address_county": "Sacramento County",
  "property_neighborhood_address": "North Sacramento",
  "property_address_latitude": "38.6086306",
  "property_address_longitude": "-121.5186241",
  "property_email": "riverpointe@ctlmanagement.com",
  "property_phone": "(279) 256-3442",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At River Pointe in Sacramento, CA, choose from stylish one and two-bedroom floor plans tailored for your lifestyle. Enjoy sunny days at our three outdoor swimming pools, unwind in our spas, and stay active in our fitness center. Connect with us today to find your perfect home!",
  "property_long_description": "Welcome to River Pointe, your ideal apartment community located in the vibrant heart of Sacramento, CA. Discover a perfect blend of comfort and convenience with our thoughtfully designed floor plans, featuring spacious One and Two Bedroom apartments tailored to meet your needs. Each residence provides a cozy retreat, thoughtfully equipped to enhance your lifestyle.\n\nAt River Pointe, we prioritize your leisure and wellness with exceptional amenities. Dive into relaxation at our three sparkling outdoor swimming pools or unwind in any of our three rejuvenating spas, perfect for soaking away the stresses of the day. For those who value an active lifestyle, our state-of-the-art fitness center is at your disposal, ensuring you can maintain your fitness goals without leaving home.\n\nAdditional conveniences include reserved parking for hassle-free access and community-wide features designed to elevate your living experience. Whether you're entertaining friends, enjoying quiet time by the pool, or working out in our fitness center, River Pointe offers an inviting, vibrant atmosphere that feels like home.\n\nDon't miss out on the opportunity to make River Pointe your new address! Our dedicated team is here to assist you every step of the way in finding the perfect apartment to suit your lifestyle. Browse our availability or schedule a tour today to experience firsthand what makes our community a special place to call home. Embrace the River Pointe lifestyle and start your new adventure in Sacramento!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019db18a-b086-75cf-9344-b080d95415b6.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool and spa with lounge chairs and umbrellas.",
    "public_id": "019db18a-b086-75cf-9344-b080d95415b6",
    "storage_key": "property/6767906449166902/019db18a-b086-75cf-9344-b080d95415b6.webp",
    "width": 1920,
    "height": 972
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "714",
  "property_year_built": "1987",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.75910364145658",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Monthly pet rent is per pet.  Small caged animals are allowed without pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Maximum Number of Pets: 2 (Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old)\nMaximum Weight Limit: 25 pounds\nMonthly Pet Rent: $30 per pet",
  "property_online_leasing_url": "https://apartments-in-sacramento.securecafe.com/onlineleasing/river-pointe-1/guestlogin",
  "property_resident_portal_url": "https://apartments-in-sacramento.securecafenet.com/residentservices/river-pointe-1/userlogin",
  "property_apply_now_url": "https://apartments-in-sacramento.securecafe.com/onlineleasing/river-pointe-1/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019db14a-3994-7244-9c8e-efff9f9b73cb.webp",
  "property_primary_logo_media": {
    "alt_text": "River Pointe Apartments logo",
    "public_id": "019db14a-3994-7244-9c8e-efff9f9b73cb",
    "storage_key": "property/6767906449166902/019db14a-3994-7244-9c8e-efff9f9b73cb.webp",
    "width": 555,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019db14a-39d5-767e-bf03-41e15b3639e4.webp",
  "property_secondary_logo_media": {
    "alt_text": "River Pointe Apartments logo",
    "public_id": "019db14a-39d5-767e-bf03-41e15b3639e4",
    "storage_key": "property/6767906449166902/019db14a-39d5-767e-bf03-41e15b3639e4.webp",
    "width": 562,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019de0b2-7cc3-7774-b19d-eb3e038a84da.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Generic placeholder image with a white center and dark borders.",
    "public_id": "019de0b2-7cc3-7774-b19d-eb3e038a84da",
    "storage_key": "property/6767906449166902/019de0b2-7cc3-7774-b19d-eb3e038a84da.webp",
    "width": 555,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019de0b2-6f91-700b-b034-b88e52ea3afc.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Black screen",
    "public_id": "019de0b2-6f91-700b-b034-b88e52ea3afc",
    "storage_key": "property/6767906449166902/019de0b2-6f91-700b-b034-b88e52ea3afc.webp",
    "width": 555,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "655 - 875",
  "property_sqft_min": "655",
  "property_sqft_max": "875",
  "property_price_range": "1520 - 2280",
  "property_price_min": "1520",
  "property_price_max": "2280",
  "property_available_units": 16,
  "property_facebook_url": "https://m.facebook.com/RiverPointeApartmentHomes/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJkZrBlo7WmoARdokzOB-crCY",
  "property_youtube_url": "https://www.youtube.com/watch?v=OXoHgzrIZSs",
  "property_yelp_url": "https://www.yelp.com/biz/delta-pointe-apartments-sacramento",
  "property_tiktok_url": "https://www.tiktok.com/@hoodmaps/video/7539968110439173431#:~:text=Explore%20dangerous%20neighborhoods%20in%20Sacramento,at:%20Feedback%20and%20help%20%2D%20TikTok&text=How%20about%20towns%20to%20avoid,and%20more.&text=I%20lived%20here%2030%20years,the%20heck%20is%20Hagginwood??&text=Gardenland?,have%20never%20heard%20of%20this.&text=I%20live%20in%20SOUTH%20SAC,LOVE%20IT!&text=It%20was%20really%20bad%20in,Anyone%20agree%20or%20disagree?&text=All%203%20of%20those%20neighborhoods,behind%20in%20Sacramento%20City's%20priorities.&text=I've%20lived%20in%20sac,have%20never%20heard%20of%20Gardenland.",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to River Pointe",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection in Your New Home",
  "property_home_amenities_blurb": "At River Pointe in Sacramento, CA, elevate your lifestyle with spacious one- and two-bedroom floor plans designed for comfort. Dive into relaxation with three inviting outdoor swimming pools and unwind in three soothing spas. Plus, enjoy the convenience of reserved parking and a state-of-the-art fitness center right at your doorstep!",
  "property_home_floorplans_blurb": "Welcome to River Pointe in sunny Sacramento, CA, where stylish living meets nature's embrace. Discover thoughtfully designed apartment homes that cater to your unique lifestyle. Each floor plan combines modern comfort with stunning views, providing the perfect backdrop for your next adventure. Browse today and find your ideal sanctuary!",
  "property_home_gallery_blurb": "Welcome to River Pointe in vibrant Sacramento, CA, where comfort meets style. Choose from our spacious one or two-bedroom floor plans, and indulge in luxurious amenities like three sparkling outdoor swimming pools, inviting spas, and a state-of-the-art fitness center. Picture yourself living here—your oasis awaits!",
  "property_home_neighborhood_blurb": "At River Pointe, vibrant living meets convenience in Sacramento. Choose from thoughtfully designed one and two-bedroom floor plans while enjoying nearby gems like the Sacramento Zoo, California State Capitol Museum, and McKinley Park. Dive into local culture and adventure—your new home is at the heart of it all!",
  "property_home_reviews_blurb": "At River Pointe in Sacramento, community living comes alive! Our residents rave about the \"serene river views and friendly atmosphere,\" making it the perfect place to call home. Curious about the experience? See what our residents have to say about living at our community and feel the warmth for yourself!",
  "property_neighborhood_blurb": "Welcome to River Pointe in Sacramento, where adventure meets convenience! Nestled near cultural treasures like the California State Capitol Museum and the Sacramento Zoo, our community is perfect for those who seek vibrant local experiences. Enjoy easy access to parks, universities, and recreational venues. Dive into the heartbeat of your neighborhood!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At River Pointe in Sacramento, CA, our vibrant community awaits you! Choose from spacious one and two-bedroom floor plans, then unwind at one of our three sparkling outdoor pools or rejuvenate in the spas. Enjoy reserved parking and a state-of-the-art fitness center, completing your ideal living experience.",
  "property_applynow_blurb": "At River Pointe in Sacramento, CA, your ideal living space awaits. Choose from stylish one and two-bedroom floor plans, unwind by one of our three outdoor swimming pools or spas, and enjoy the convenience of reserved parking and a fully-equipped fitness center. Lease your new home online today!",
  "property_contactus_blurb": "At River Pointe in Sacramento, CA, our thoughtfully designed one and two-bedroom floor plans offer a perfect blend of comfort and style. Whether you seek a cozy retreat or a spacious haven, we have options to suit your lifestyle. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At River Pointe in Sacramento, CA, we offer spacious one and two-bedroom floor plans tailored to your lifestyle. Have questions? Our FAQs page is your go-to resource for everything you need to know about our vibrant community. Dive in for insights designed to make your living experience unforgettable!",
  "property_floorplans_blurb": "At River Pointe in Sacramento, CA, your ideal living space awaits. Choose from spacious one and two-bedroom floor plans that blend style and comfort. Let the tranquil ambiance enhance your lifestyle. Browse our available apartment homes today and find the perfect floor plan tailored just for you!",
  "property_gallery_blurb": "At River Pointe in Sacramento, CA, vibrant living awaits in our beautifully designed one- and two-bedroom apartments. Lounge by one of three sparkling outdoor swimming pools or unwind in our soothing spas. Stay fit in our state-of-the-art fitness center. Picture yourself living here—your oasis of comfort and relaxation!",
  "property_interactivemap_blurb": "At River Pointe in Sacramento, CA, indulge in a lifestyle of comfort with spacious one- and two-bedroom floor plans. Enjoy resort-style amenities, including three sparkling swimming pools, rejuvenating spas, and a state-of-the-art fitness center. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At River Pointe in Sacramento, your furry friends will feel right at home. With a focus on comfort, we welcome indoor adult cats and dogs up to 25 lbs. Enjoy pet-friendly amenities and cozy living spaces, making every day a paw-sitive experience for you and your companions!",
  "property_referafriend_blurb": "At River Pointe in Sacramento, CA, your ideal living space awaits! Choose from spacious one and two-bedroom floor plans that offer comfort and style. Great friends make great neighbors—refer a friend today and share the joy of riverside living in our vibrant community! Embrace life together at River Pointe!",
  "property_residentaccess_blurb": "At River Pointe in Sacramento, our diverse floor plans, from cozy one-bedroom to spacious two-bedroom apartments, cater to your lifestyle needs. Enhance your living experience by accessing your resident portal to conveniently pay rent, schedule maintenance, and stay connected. Your comfort and convenience are just a click away!",
  "property_reviews_blurb": "At River Pointe in Sacramento, residents rave about the vibrant community and stunning riverside views, with one saying, “Living here feels like a daily retreat!” Want to understand why our residents love calling River Pointe home? See what they have to say about life in this exceptional community!",
  "property_created_at": "1762785046969",
  "property_scheduletour_blurb": "At River Pointe in vibrant Sacramento, CA, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Ready for a closer look? Schedule a tour today and hear firsthand why our residents love calling this community home! Your ideal living space awaits!",
  "property_thankyou_blurb": "Thank you for your interest in River Pointe in beautiful Sacramento, CA! Whether you’re seeking a cozy one-bedroom retreat or a spacious two-bedroom haven, our thoughtfully designed floor plans cater to your unique lifestyle. A team member will reach out shortly to assist you on your journey to finding your new home!",
  "property_virtualtours_blurb": "Experience the charm of River Pointe in Sacramento, CA, where our thoughtfully designed one and two-bedroom apartments blend comfort and style. Enjoy serene views and modern amenities, all in a vibrant community setting. Ready to find your new home? Take a virtual tour of our stunning apartments today!",
  "property_copyright": "2025 All Rights Reserved. River Pointe",
  "property_seo_title_home": "River Pointe |  Apartments in Sacramento, CA",
  "property_seo_description_home": "Discover River Pointe in Sacramento, CA—luxurious one and two-bedroom apartments with pools, spas, and a fitness center for your comfort!",
  "property_seo_title_floorplans": "Floor Plans | Sacramento, CA Apartments for Rent",
  "property_seo_description_floorplans": "Uncover your ideal living space at River Pointe in Sacramento! Choose from stylish one or two-bedroom floor plans designed for modern comfort. Browse now!",
  "property_seo_title_amenities": "Amenities | Sacramento, CA Apartments for Rent",
  "property_seo_description_amenities": "Dive into River Pointe's luxurious amenities: 3 sparkling pools, relaxing spas, a top-notch fitness center, and spacious floor plans in beautiful Sacramento!",
  "property_seo_title_gallery": "Gallery | Apartments in Sacramento, CA",
  "property_seo_description_gallery": "Picture yourself at River Pointe in Sacramento, CA! Dive into luxury with 3 pools, fitness center & stunning views. Your ideal home awaits—see the splendor!",
  "property_seo_title_virtualtours": "Virtual Tours | River Pointe Apartments",
  "property_seo_description_virtualtours": "Experience River Pointe in Sacramento! Take a virtual tour of our one and two-bedroom apartments, where comfort meets style in a vibrant community.",
  "property_seo_title_interactivemap": "Interactive Map | River Pointe Apartments",
  "property_seo_description_interactivemap": "Find your perfect sanctuary at River Pointe in Sacramento, CA. Use our interactive map to view available one and two-bedroom apartments and amenities galore!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Sacramento, CA",
  "property_seo_description_neighborhood": "Experience the vibrant heart of Sacramento at River Pointe! Dive into local favorites and hidden gems just moments from your doorstep.",
  "property_seo_title_contact": "Contact Us | River Pointe",
  "property_seo_description_contact": "Reach out to River Pointe in Sacramento, CA, for any inquiries. Our friendly leasing team is ready to assist you with one and two-bedroom floor plans!",
  "property_seo_title_faqs": "FAQs | Apartments in Sacramento, CA",
  "property_seo_description_faqs": "Unlock peace of mind at River Pointe in Sacramento, CA! Dive into our FAQs for insights on our one and two-bedroom homes, pools, perks, and more!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Sacramento, CA",
  "property_seo_description_reviews": "Join the River Pointe community in Sacramento! With stunning pools, a fitness center, and glowing resident reviews, see why everyone loves calling us home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Sacramento, CA",
  "property_seo_description_applynow": "Find your perfect fit at River Pointe in Sacramento! Enjoy pools, spas, and a fitness center. Apply online and make your dream home a reality today!",
  "property_seo_title_residentaccess": "Resident Access | River Pointe",
  "property_seo_description_residentaccess": "Streamline your living at River Pointe! Log in to your portal for rent payments, maintenance requests, and exclusive community updates in Sacramento, CA.",
  "property_seo_title_referafriend": "Refer A Friend | River Pointe",
  "property_seo_description_referafriend": "Refer a friend to River Pointe in Sacramento! Share the vibrant community experience where great friends become great neighbors. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | River Pointe",
  "property_seo_description_scheduletour": "Discover the charm of River Pointe in Sacramento. Schedule a tour today and imagine your new life in our vibrant, convenient community!",
  "property_seo_title_privacy": "Privacy Policy | River Pointe",
  "property_seo_description_privacy": "Safeguarding your peace of mind at River Pointe. Read our privacy policy to learn how we protect your information in beautiful Sacramento, CA.",
  "property_seo_title_accessibility": "Website Accessibility | River Pointe",
  "property_seo_description_accessibility": "At River Pointe, we ensure accessibility for all with a focus on digital inclusion and community connection for comfortable living.",
  "property_seo_title_sitemap": "Sitemap | River Pointe",
  "property_seo_description_sitemap": "Navigate your way to endless possibilities at River Pointe in Sacramento, CA. Visit our sitemap for a seamless journey to your next home!",
  "property_seo_title_thankyou": "Thank You | River Pointe",
  "property_seo_description_thankyou": "Thank you for contacting River Pointe! We'll respond quickly to assist you in finding your ideal Sacramento home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Sacramento, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1778875128663",
  "amenities": [
    {
      "id": "ec_19b46dbe921f437076dbd52a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "80429298",
      "title": "Business Center Media Lounge with Guest Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd0-cb63-7295-8874-7f9d402af491.webp",
      "amenity_image_media": {
        "alt_text": "Business center with computers and printers",
        "public_id": "019d4cd0-cb63-7295-8874-7f9d402af491",
        "storage_key": "property/6767906449166902/019d4cd0-cb63-7295-8874-7f9d402af491.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Business center at River Pointe, Sacramento, California,Clubhouse TV Lounge at River Pointe, Sacramento, California 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff501793e276745cd9061968",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "80429294",
      "title": "24 Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4973-3951-7336-a967-7d5f32fc5e37.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with cardio machines, weight machines, and free weights.",
        "public_id": "019d4973-3951-7336-a967-7d5f32fc5e37",
        "storage_key": "property/6767906449166902/019d4973-3951-7336-a967-7d5f32fc5e37.webp",
        "width": 1200,
        "height": 798
      },
      "amenity_image_alt_text": "Fitness Center & Strength Equipment at River Pointe, California,Fitness Center & Cardio Equipment at River Pointe, Sacramento",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f3514a42fff4b8b8c25ea59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "80429296",
      "title": "3 Sparkling Swimming Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd0-4cd7-71c8-a89a-98b516dd7ce8.webp",
      "amenity_image_media": {
        "alt_text": "Swimming pool and jacuzzi area with lounge chairs and umbrellas.",
        "public_id": "019d4cd0-4cd7-71c8-a89a-98b516dd7ce8",
        "storage_key": "property/6767906449166902/019d4cd0-4cd7-71c8-a89a-98b516dd7ce8.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Side A swimming pool with pool furniture at River Pointe, Sacramento, California,Side A swimming pool at River Pointe, Sacramento, California",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a2bccf81f7d40a649c9be2d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "80429334",
      "title": "3 Spas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd0-6ffc-73d9-9adf-6e12dd46076e.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style swimming pool and hot tub with lounge chairs and umbrellas.",
        "public_id": "019d4cd0-6ffc-73d9-9adf-6e12dd46076e",
        "storage_key": "property/6767906449166902/019d4cd0-6ffc-73d9-9adf-6e12dd46076e.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Side A swimming pool and spa with clubhouse view at River Pointe, Sacramento, California,Side A swimming pool and spa at River Pointe, Sacramento, California",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_85f95684fccb08f0169c8db0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "80429302",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd1-2b19-726f-8163-8878d1cee4c3.webp",
      "amenity_image_media": {
        "alt_text": "Playground with slides and climbing wall at apartment complex.",
        "public_id": "019d4cd1-2b19-726f-8163-8878d1cee4c3",
        "storage_key": "property/6767906449166902/019d4cd1-2b19-726f-8163-8878d1cee4c3.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Playground and play structure at River Pointe, Sacramento, California",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f5a231316a89a966e0c4bd46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "80429304",
      "title": "Tennis Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4973-274e-71ed-8210-a8f3c4e58518.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of an apartment complex pool and tennis court.",
        "public_id": "019d4973-274e-71ed-8210-a8f3c4e58518",
        "storage_key": "property/6767906449166902/019d4973-274e-71ed-8210-a8f3c4e58518.webp",
        "width": 1200,
        "height": 674
      },
      "amenity_image_alt_text": "Exterior Amenities Aerial Shot at River Pointe, Sacramento, California 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d70017234c118e144da98a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "121139206",
      "title": "Volleyball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d9a48-eda9-735a-acf8-90e08036d7f3.webp",
      "amenity_image_media": {
        "alt_text": "Volleyball court in front of apartment buildings",
        "public_id": "019d9a48-eda9-735a-acf8-90e08036d7f3",
        "storage_key": "property/6767906449166902/019d9a48-eda9-735a-acf8-90e08036d7f3.webp",
        "width": 1196,
        "height": 795
      },
      "amenity_image_alt_text": "Outdoor Volleyball Court at River Pointe Apartments in Natomas, CA",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_edf0c437d4946af73a831ee6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "80429299",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4973-274e-71ed-8210-a8f3c4e58518.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of an apartment complex pool and tennis court.",
        "public_id": "019d4973-274e-71ed-8210-a8f3c4e58518",
        "storage_key": "property/6767906449166902/019d4973-274e-71ed-8210-a8f3c4e58518.webp",
        "width": 1200,
        "height": 674
      },
      "amenity_image_alt_text": "Exterior Amenities Aerial Shot at River Pointe, Sacramento, 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43352890b943bb94b3e5655b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "86455052",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee5c7cae6c7fa9544d6a4a49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "86391313",
      "title": "24-Hour Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4973-3614-728b-aada-fd63cda897aa.webp",
      "amenity_image_media": {
        "alt_text": "River Pointe package lockers",
        "public_id": "019d4973-3614-728b-aada-fd63cda897aa",
        "storage_key": "property/6767906449166902/019d4973-3614-728b-aada-fd63cda897aa.webp",
        "width": 962,
        "height": 560
      },
      "amenity_image_alt_text": "24-Hour Package Room and Hub Package Locker at River Pointe, CA 95833,24-Hour Package Room and Hub Package Locker with Touch Screen at River Pointe, California, 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_57dcb1421cbbd824731caccf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "80429303",
      "title": "Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_250153af8883bbd9ffc67f71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "80429300",
      "title": "Freeway Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a7058eada7a71c2a73ae0776",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "86455053",
      "title": "Flexible Lease Terms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c027b21ccb6147102ee6d850",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "80429301",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56c54735315c980625814639",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "82390235",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e4ba874027e3ed72187b49d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "82390237",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dfd1b3b9ee228d96ce8820bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "86455054",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ae80e9414441aca4b7f3256",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "80429311",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4ccf-e79c-713b-867f-12c1755700d0.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with white cabinets, black appliances, and a stacked washer/dryer unit.",
        "public_id": "019d4ccf-e79c-713b-867f-12c1755700d0",
        "storage_key": "property/6767906449166902/019d4ccf-e79c-713b-867f-12c1755700d0.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Model 1x1 kitchen and laundry at River Pointe, Sacramento, California,Model 2x2 laundry and dining room at River Pointe, Sacramento, California",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51c8e2497c5c06e9c006642d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "80429309",
      "title": "Centralized Heating And Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d3913a2dd348f38f0974ad2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "80429307",
      "title": "Attached Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fbddcd36b6a63e83227a98c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "80429310",
      "title": "Fireplace - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8226dd3f266c6c239a1a2574",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "yardi",
      "external_id": "87310445",
      "title": "Patio or Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_429b52dbdc8d4b520d5cdc7c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d42a9-8508-7105-b5bd-2210e809f897.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, black appliances, and stacked washer/dryer.",
        "public_id": "019d42a9-8508-7105-b5bd-2210e809f897",
        "storage_key": "property/6767906449166902/019d42a9-8508-7105-b5bd-2210e809f897.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Updated kitchen featuring white cabinetry, granite-style countertops, a dishwasher, stove, and a stacked washer and dryer for convenience.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, black appliances, and stacked washer/dryer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_Model2x2KitchenLaundry.jpg"
    },
    {
      "id": "ec_51a987da7fc0ca9086f354c7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4ccf-7652-7584-91ad-c4162eeff86c.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with black appliances and white cabinets.",
        "public_id": "019d4ccf-7652-7584-91ad-c4162eeff86c",
        "storage_key": "property/6767906449166902/019d4ccf-7652-7584-91ad-c4162eeff86c.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Enjoy convenient dining and cooking in this apartment's functional kitchen and dining area, featuring modern black appliances and ample cabinet space.",
      "link": "false",
      "alt_text": "Dining area and kitchen with black appliances and white cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_Model2x2DiningRoom.jpg"
    },
    {
      "id": "ec_43d03c1849a34dad2a1dcc93",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4ccf-74c8-7165-86b5-f5d7a99314fc.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer in a closet, with a view into the dining area and living room.",
        "public_id": "019d4ccf-74c8-7165-86b5-f5d7a99314fc",
        "storage_key": "property/6767906449166902/019d4ccf-74c8-7165-86b5-f5d7a99314fc.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer located in a dedicated closet. Enjoy a spacious living area and dining space.",
      "link": "false",
      "alt_text": "Stackable washer and dryer in a closet, with a view into the dining area and living room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_Model2x2LaundryDiningRoom.jpg"
    },
    {
      "id": "ec_cbe634c35018d56577404306",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4ccf-92db-7729-9d3a-e6817ac4d34b.webp",
      "image_media": {
        "alt_text": "Living room with a couch, two chairs, coffee table, and a large window.",
        "public_id": "019d4ccf-92db-7729-9d3a-e6817ac4d34b",
        "storage_key": "property/6767906449166902/019d4ccf-92db-7729-9d3a-e6817ac4d34b.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Enjoy this beautifully decorated living room, featuring a plush couch, elegant accent chairs, and a modern coffee table.",
      "link": "false",
      "alt_text": "Living room with a couch, two chairs, coffee table, and a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_Model2x2LivingRoom2ndView.jpg"
    },
    {
      "id": "ec_a7510e7e59ee5f104a98ea01",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4ccf-7609-7256-a1e8-9f856902eb2a.webp",
      "image_media": {
        "alt_text": "A plush bed with light blue linens and decorative pillows sits in a well-lit bedroom.",
        "public_id": "019d4ccf-7609-7256-a1e8-9f856902eb2a",
        "storage_key": "property/6767906449166902/019d4ccf-7609-7256-a1e8-9f856902eb2a.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a queen-size bed with plush bedding and elegant accents.",
      "link": "false",
      "alt_text": "A plush bed with light blue linens and decorative pillows sits in a well-lit bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_Model2x2PrimaryBedroom.jpg"
    },
    {
      "id": "ec_c00e3fa55e000afcdec1f519",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4ccf-74c5-7313-9a0a-010049d44cd9.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, dresser, and closet.",
        "public_id": "019d4ccf-74c5-7313-9a0a-010049d44cd9",
        "storage_key": "property/6767906449166902/019d4ccf-74c5-7313-9a0a-010049d44cd9.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, a dresser for storage, and a convenient closet. Enjoy a relaxing retreat in this well-appointed apartment space.",
      "link": "false",
      "alt_text": "Bedroom with a bed, dresser, and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_Model2x2PrimaryBedroomCloset.jpg"
    },
    {
      "id": "ec_2bbf6b1cc9093ed10b1f3e04",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4ccf-b03d-705a-8b1a-fa86db58a47a.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, countertop, mirror, and cabinet, with a view into the shower/tub area.",
        "public_id": "019d4ccf-b03d-705a-8b1a-fa86db58a47a",
        "storage_key": "property/6767906449166902/019d4ccf-b03d-705a-8b1a-fa86db58a47a.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a spacious vanity with ample storage and a separate shower and tub area.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink, countertop, mirror, and cabinet, with a view into the shower/tub area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_Model2x2PrimaryBathroom.jpg"
    },
    {
      "id": "ec_070c54b522e2771e13ffc611",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4ccf-b1cd-72bc-a9ec-a99501835b63.webp",
      "image_media": {
        "alt_text": "Bedroom with a single daybed, a dresser, and artwork.",
        "public_id": "019d4ccf-b1cd-72bc-a9ec-a99501835b63",
        "storage_key": "property/6767906449166902/019d4ccf-b1cd-72bc-a9ec-a99501835b63.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "This bedroom features a comfortable daybed with striped pillows, a stylish mid-century modern dresser, and unique wall art. Perfect for relaxation and personal expression.",
      "link": "false",
      "alt_text": "Bedroom with a single daybed, a dresser, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_Model2x2SecondBedroom.jpg"
    },
    {
      "id": "ec_9f49e10546f38319657f4722",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4ccf-b66b-715d-985f-d0b4d936e302.webp",
      "image_media": {
        "alt_text": "Bathroom with white vanity, granite countertop, and walk-in shower.",
        "public_id": "019d4ccf-b66b-715d-985f-d0b4d936e302",
        "storage_key": "property/6767906449166902/019d4ccf-b66b-715d-985f-d0b4d936e302.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a white vanity with granite countertops, a large mirror, and a walk-in shower with a patterned shower curtain.",
      "link": "false",
      "alt_text": "Bathroom with white vanity, granite countertop, and walk-in shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_Model2x2SecondBathroom.jpg"
    },
    {
      "id": "ec_7e308aa7eb61fe46a5e0b20b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4ccf-c21f-70af-b225-77218e40dd5e.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, black appliances, and granite countertops.",
        "public_id": "019d4ccf-c21f-70af-b225-77218e40dd5e",
        "storage_key": "property/6767906449166902/019d4ccf-c21f-70af-b225-77218e40dd5e.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Updated kitchen featuring white cabinetry, black appliances including a stove and dishwasher, and granite countertops.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, black appliances, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_Model1x1Kitchen.jpg"
    },
    {
      "id": "ec_320b6c24ceba2d03debf4203",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4ccf-e79c-713b-867f-12c1755700d0.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, black appliances, and a stacked washer/dryer unit.",
        "public_id": "019d4ccf-e79c-713b-867f-12c1755700d0",
        "storage_key": "property/6767906449166902/019d4ccf-e79c-713b-867f-12c1755700d0.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring white cabinetry, a full-size black range, dishwasher, and a stacked washer and dryer for ultimate convenience.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, black appliances, and a stacked washer/dryer unit.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_Model1x1KitchenLaundry.jpg"
    },
    {
      "id": "ec_10a585759d330bc83a1aacfc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4ccf-efd2-7230-a68c-9b7c7f6f6cec.webp",
      "image_media": {
        "alt_text": "Dining area with a glass table set for two, next to a kitchen with black appliances and white cabinetry.",
        "public_id": "019d4ccf-efd2-7230-a68c-9b7c7f6f6cec",
        "storage_key": "property/6767906449166902/019d4ccf-efd2-7230-a68c-9b7c7f6f6cec.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Enjoy meals in this inviting dining area, adjacent to a fully equipped kitchen featuring modern black appliances and ample white cabinetry for all your storage needs.",
      "link": "false",
      "alt_text": "Dining area with a glass table set for two, next to a kitchen with black appliances and white cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_Model1x1DiningRoom.jpg"
    },
    {
      "id": "ec_9f36a7c2c2f6fccd0f4ceaa4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4ccf-f179-766f-bdbb-c3cfa84b3bee.webp",
      "image_media": {
        "alt_text": "Glass dining table with chairs set for a meal, adjacent to a living room area with a sofa and coffee table.",
        "public_id": "019d4ccf-f179-766f-bdbb-c3cfa84b3bee",
        "storage_key": "property/6767906449166902/019d4ccf-f179-766f-bdbb-c3cfa84b3bee.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Enjoy elegant dining and comfortable living in this apartment's combined dining and living space, perfect for entertaining guests or relaxing.",
      "link": "false",
      "alt_text": "Glass dining table with chairs set for a meal, adjacent to a living room area with a sofa and coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_Model1x1DiningRoomLivingRoom.jpg"
    },
    {
      "id": "ec_1b4787bbcf033a1be29e4266",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4ccf-f7b9-75b7-8798-b8614ccde0b7.webp",
      "image_media": {
        "alt_text": "Living room with a TV, coffee table, armchair, and sofa.",
        "public_id": "019d4ccf-f7b9-75b7-8798-b8614ccde0b7",
        "storage_key": "property/6767906449166902/019d4ccf-f7b9-75b7-8798-b8614ccde0b7.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a large flat-screen TV, a glass coffee table, and comfortable seating with decorative pillows. Artwork adorns the wall.",
      "link": "false",
      "alt_text": "Living room with a TV, coffee table, armchair, and sofa.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_Model1x1LivingRoomtoDiningRoom.jpg"
    },
    {
      "id": "ec_0a173433ea355bd419973e5a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd0-0a09-762e-8c84-34462000b6f9.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, two nightstands with lamps, and framed artwork on the wall.",
        "public_id": "019d4cd0-0a09-762e-8c84-34462000b6f9",
        "storage_key": "property/6767906449166902/019d4cd0-0a09-762e-8c84-34462000b6f9.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "A comfortable and well-appointed bedroom featuring a queen-size bed, ample storage, and decorative wall art, creating a relaxing atmosphere.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, two nightstands with lamps, and framed artwork on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_Model1x1Bedroom.jpg"
    },
    {
      "id": "ec_fe95b08ff05011087d01b738",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd0-28fe-760a-a140-0139b773d766.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen size bed, nightstand, and dresser.",
        "public_id": "019d4cd0-28fe-760a-a140-0139b773d766",
        "storage_key": "property/6767906449166902/019d4cd0-28fe-760a-a140-0139b773d766.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a queen size bed, cozy bedding, bedside lamps, and a dresser for ample storage. A walk-in closet is also visible.",
      "link": "false",
      "alt_text": "Bedroom with a queen size bed, nightstand, and dresser.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_Model1x1BedroomCloset.jpg"
    },
    {
      "id": "ec_e051fb2305cddbfa402781d8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd0-2cd9-75e8-b295-e17e8596a31d.webp",
      "image_media": {
        "alt_text": "Bathroom with bathtub, toilet, and vanity with sink.",
        "public_id": "019d4cd0-2cd9-75e8-b295-e17e8596a31d",
        "storage_key": "property/6767906449166902/019d4cd0-2cd9-75e8-b295-e17e8596a31d.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Clean and modern bathroom featuring a bathtub/shower combo, toilet, and a vanity with a granite countertop and sink.",
      "link": "false",
      "alt_text": "Bathroom with bathtub, toilet, and vanity with sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_Model1x1Bathroom.jpg"
    },
    {
      "id": "ec_a4870ff3118994bb0bd4c934",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd0-3499-742e-9d5c-1f25145aecb6.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and lush trees.",
        "public_id": "019d4cd0-3499-742e-9d5c-1f25145aecb6",
        "storage_key": "property/6767906449166902/019d4cd0-3499-742e-9d5c-1f25145aecb6.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, perfect for relaxing and soaking up the sun. Lounge chairs and umbrellas provide ultimate comfort.",
      "link": "false",
      "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and lush trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_SwimmingPoolA.jpg"
    },
    {
      "id": "ec_8c738478624ea98ff8181523",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd0-4cd7-71c8-a89a-98b516dd7ce8.webp",
      "image_media": {
        "alt_text": "Swimming pool and jacuzzi area with lounge chairs and umbrellas.",
        "public_id": "019d4cd0-4cd7-71c8-a89a-98b516dd7ce8",
        "storage_key": "property/6767906449166902/019d4cd0-4cd7-71c8-a89a-98b516dd7ce8.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool and bubbling jacuzzi. Enjoy the sun under our stylish umbrellas or lounge on the comfortable chaises.",
      "link": "false",
      "alt_text": "Swimming pool and jacuzzi area with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_SwimmingPoolAFurniture.jpg"
    },
    {
      "id": "ec_ce46b0863fe9cfed09d7dbf6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd0-4ec5-73dd-ae11-0b4d3241c5df.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and spa with lounge chairs and umbrellas.",
        "public_id": "019d4cd0-4ec5-73dd-ae11-0b4d3241c5df",
        "storage_key": "property/6767906449166902/019d4cd0-4ec5-73dd-ae11-0b4d3241c5df.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our sparkling swimming pool or unwind in the soothing spa. Perfect for soaking up the sun and escaping the everyday.",
      "link": "false",
      "alt_text": "Resort-style swimming pool and spa with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_SwimmingPoolSpaA.jpg"
    },
    {
      "id": "ec_ee6ffebc86aae632b3039757",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd0-6ffc-73d9-9adf-6e12dd46076e.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and hot tub with lounge chairs and umbrellas.",
        "public_id": "019d4cd0-6ffc-73d9-9adf-6e12dd46076e",
        "storage_key": "property/6767906449166902/019d4cd0-6ffc-73d9-9adf-6e12dd46076e.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy our sparkling swimming pool and relaxing hot tub, perfect for soaking up the sun and unwinding.",
      "link": "false",
      "alt_text": "Resort-style swimming pool and hot tub with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_SwimmingPoolSpaAClubhouseView.jpg"
    },
    {
      "id": "ec_124d166c5f7fbde7f454fa6e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4973-274e-71ed-8210-a8f3c4e58518.webp",
      "image_media": {
        "alt_text": "Aerial view of an apartment complex pool and tennis court.",
        "public_id": "019d4973-274e-71ed-8210-a8f3c4e58518",
        "storage_key": "property/6767906449166902/019d4973-274e-71ed-8210-a8f3c4e58518.webp",
        "width": 1200,
        "height": 674
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling pool or a friendly match on the tennis court at this apartment community.",
      "link": "false",
      "alt_text": "Aerial view of an apartment complex pool and tennis court.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_AmenitiesAerial.jpg"
    },
    {
      "id": "ec_f007c05d00c063a2168e258f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4973-25be-71e4-bb05-bf9518bd9347.webp",
      "image_media": {
        "alt_text": "Gym with cardio equipment and mirrors",
        "public_id": "019d4973-25be-71e4-bb05-bf9518bd9347",
        "storage_key": "property/6767906449166902/019d4973-25be-71e4-bb05-bf9518bd9347.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Community",
      "description": "State-of-the-art fitness center equipped with cardio machines, weight training equipment, and plenty of space to achieve your fitness goals.",
      "link": "false",
      "alt_text": "Gym with cardio equipment and mirrors",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_FitnessCenter03.jpg"
    },
    {
      "id": "ec_b6f594e904cc1df56fd705ca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4973-3951-7336-a967-7d5f32fc5e37.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight machines, and free weights.",
        "public_id": "019d4973-3951-7336-a967-7d5f32fc5e37",
        "storage_key": "property/6767906449166902/019d4973-3951-7336-a967-7d5f32fc5e37.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Community",
      "description": "State-of-the-art fitness center equipped with cardio machines, weight training equipment, and free weights for a complete workout.",
      "link": "false",
      "alt_text": "Fitness center with cardio machines, weight machines, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_FitnessCenter01.jpg"
    },
    {
      "id": "ec_368bb82a6a52b8b667ee346c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4973-3614-728b-aada-fd63cda897aa.webp",
      "image_media": {
        "alt_text": "River Pointe package lockers",
        "public_id": "019d4973-3614-728b-aada-fd63cda897aa",
        "storage_key": "property/6767906449166902/019d4973-3614-728b-aada-fd63cda897aa.webp",
        "width": 962,
        "height": 560
      },
      "title": "Community",
      "description": "Secure package lockers for all units at River Pointe, offering convenient and safe package delivery.",
      "link": "false",
      "alt_text": "River Pointe package lockers",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/River Pointe 24-Hour Hub Package Locker - Copy.jpg"
    },
    {
      "id": "ec_b5c3f3b80d1e95a00b4cc220",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4973-36d4-762d-ba0d-af63eaea9c3f.webp",
      "image_media": {
        "alt_text": "Secure package lockers with digital screen and keypad",
        "public_id": "019d4973-36d4-762d-ba0d-af63eaea9c3f",
        "storage_key": "property/6767906449166902/019d4973-36d4-762d-ba0d-af63eaea9c3f.webp",
        "width": 1001,
        "height": 565
      },
      "title": "Community",
      "description": "Modern and secure package lockers for residents, featuring a digital screen and keypad for easy access and notifications. Conveniently located within the community.",
      "link": "false",
      "alt_text": "Secure package lockers with digital screen and keypad",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/River Pointe 24-Hour Hub Package Lockers - Copy.jpg"
    },
    {
      "id": "ec_64b2a0d5ab26491bc855adab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd0-7da7-705a-bc61-f73991c31d1a.webp",
      "image_media": {
        "alt_text": "River Pointe monument sign with landscaping",
        "public_id": "019d4cd0-7da7-705a-bc61-f73991c31d1a",
        "storage_key": "property/6767906449166902/019d4cd0-7da7-705a-bc61-f73991c31d1a.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Welcome to River Pointe, featuring a monument sign with the property name and beautiful landscaping.",
      "link": "false",
      "alt_text": "River Pointe monument sign with landscaping",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_EntryMonument.jpg"
    },
    {
      "id": "ec_ff62fc96419f90c319b0aa42",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd0-93de-7111-ad0d-11da00c0df55.webp",
      "image_media": {
        "alt_text": "River Pointe apartment community signage with a rock waterfall and lush landscaping.",
        "public_id": "019d4cd0-93de-7111-ad0d-11da00c0df55",
        "storage_key": "property/6767906449166902/019d4cd0-93de-7111-ad0d-11da00c0df55.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Welcome to River Pointe, a beautiful apartment community featuring a scenic rock waterfall and vibrant red flowers. Enjoy the serene atmosphere.",
      "link": "false",
      "alt_text": "River Pointe apartment community signage with a rock waterfall and lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_EntryFountainSecondMonument.jpg"
    },
    {
      "id": "ec_a916a5fb049a10de3941a87f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd0-99da-76c6-95ed-5e3e7a80f9ee.webp",
      "image_media": {
        "alt_text": "Landscaping with a waterfall, pond, and flowering plants at River Pointe apartments.",
        "public_id": "019d4cd0-99da-76c6-95ed-5e3e7a80f9ee",
        "storage_key": "property/6767906449166902/019d4cd0-99da-76c6-95ed-5e3e7a80f9ee.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy the beautifully landscaped grounds and tranquil water features, including a waterfall and pond, at River Pointe apartments.",
      "link": "false",
      "alt_text": "Landscaping with a waterfall, pond, and flowering plants at River Pointe apartments.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_EntryFountain.jpg"
    },
    {
      "id": "ec_f6a7ce3cd1ecdaaf7484314d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd0-be18-704c-ab58-e6e8dfe3b6f2.webp",
      "image_media": {
        "alt_text": "Outdoor patio area with stone accents, lush greenery, and palm trees.",
        "public_id": "019d4cd0-be18-704c-ab58-e6e8dfe3b6f2",
        "storage_key": "property/6767906449166902/019d4cd0-be18-704c-ab58-e6e8dfe3b6f2.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy the beautiful outdoors with this inviting patio space, perfect for relaxing or entertaining, surrounded by vibrant landscaping.",
      "link": "false",
      "alt_text": "Outdoor patio area with stone accents, lush greenery, and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_ClubhouseEntry.jpg"
    },
    {
      "id": "ec_514f93c771ee1c6d2a980e11",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd0-cb63-7295-8874-7f9d402af491.webp",
      "image_media": {
        "alt_text": "Business center with computers and printers",
        "public_id": "019d4cd0-cb63-7295-8874-7f9d402af491",
        "storage_key": "property/6767906449166902/019d4cd0-cb63-7295-8874-7f9d402af491.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Stay connected in our resident business center, equipped with computers and printers for your convenience.",
      "link": "false",
      "alt_text": "Business center with computers and printers",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_BusinessCenter(1).jpg"
    },
    {
      "id": "ec_8620a9da693722885a0c240a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4973-4e1b-7149-bbf4-7eec9a40e34b.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, and TV.",
        "public_id": "019d4973-4e1b-7149-bbf4-7eec9a40e34b",
        "storage_key": "property/6767906449166902/019d4973-4e1b-7149-bbf4-7eec9a40e34b.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, coffee table with decorative items, and a large television displaying a baseball game. Modern and stylish design.",
      "link": "false",
      "alt_text": "Living room with sofa, coffee table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_Clubhouse.jpg"
    },
    {
      "id": "ec_2a854d45ecd8cbd3c798593a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd0-e340-706e-8930-30153b03ba48.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with trees and palm trees in front.",
        "public_id": "019d4cd0-e340-706e-8930-30153b03ba48",
        "storage_key": "property/6767906449166902/019d4cd0-e340-706e-8930-30153b03ba48.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Welcome to our community, featuring beautiful landscaping and exterior views of the apartment buildings.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with trees and palm trees in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_CommunityEntryDriveway.jpg"
    },
    {
      "id": "ec_d278178feb7fb0c7b03f74fe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd0-ea49-73d8-aeff-ad0dee9b5d21.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies, staircases, and manicured landscaping.",
        "public_id": "019d4cd0-ea49-73d8-aeff-ad0dee9b5d21",
        "storage_key": "property/6767906449166902/019d4cd0-ea49-73d8-aeff-ad0dee9b5d21.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "View the exteriors of our apartment buildings, featuring private balconies, convenient staircases, and lush, green landscaping.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies, staircases, and manicured landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_SideABuildingExterior.jpg"
    },
    {
      "id": "ec_9d70838388fea0f7023237e9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd0-efc6-7472-a5a2-06b16d969479.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and flowering trees.",
        "public_id": "019d4cd0-efc6-7472-a5a2-06b16d969479",
        "storage_key": "property/6767906449166902/019d4cd0-efc6-7472-a5a2-06b16d969479.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Charming apartment buildings featuring balconies, lush landscaping, and vibrant flowering trees, offering a pleasant residential atmosphere.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and flowering trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_SideABuildingExteriorEntries.jpg"
    },
    {
      "id": "ec_3154a2e2fbdd5262efc3625c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4973-81a4-7379-9a45-980755d14779.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and staircases, surrounded by lush green lawns and trees.",
        "public_id": "019d4973-81a4-7379-9a45-980755d14779",
        "storage_key": "property/6767906449166902/019d4973-81a4-7379-9a45-980755d14779.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Community",
      "description": "Discover comfortable living in our apartment community, featuring well-maintained exteriors, green spaces, and convenient access.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and staircases, surrounded by lush green lawns and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_BuildingExterior02.jpg"
    },
    {
      "id": "ec_3d472d2783717170412530b0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4973-8090-73ba-bc14-581af8c6bc4d.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with covered parking and manicured landscaping under a clear blue sky.",
        "public_id": "019d4973-8090-73ba-bc14-581af8c6bc4d",
        "storage_key": "property/6767906449166902/019d4973-8090-73ba-bc14-581af8c6bc4d.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Community",
      "description": "Discover comfortable living in our apartment community, featuring attractive exteriors, convenient covered parking, and lush green spaces.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with covered parking and manicured landscaping under a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_BuildingExterior04.jpg"
    },
    {
      "id": "ec_7bbb5861df22755894013876",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd1-2b19-726f-8163-8878d1cee4c3.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing wall at apartment complex.",
        "public_id": "019d4cd1-2b19-726f-8163-8878d1cee4c3",
        "storage_key": "property/6767906449166902/019d4cd1-2b19-726f-8163-8878d1cee4c3.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring slides and a climbing wall, perfect for family recreation.",
      "link": "false",
      "alt_text": "Playground with slides and climbing wall at apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_Playground.jpg"
    },
    {
      "id": "ec_61fec037fa3011117dc55bd4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4cd1-30f7-72d4-861d-dd876b3f1a71.webp",
      "image_media": {
        "alt_text": "Playground with slides, climbing wall, and picnic tables surrounded by trees.",
        "public_id": "019d4cd1-30f7-72d4-861d-dd876b3f1a71",
        "storage_key": "property/6767906449166902/019d4cd1-30f7-72d4-861d-dd876b3f1a71.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, complete with slides and a climbing wall. Perfect for family gatherings with nearby picnic tables.",
      "link": "false",
      "alt_text": "Playground with slides, climbing wall, and picnic tables surrounded by trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_PlaygroundPicnicArea.jpg"
    },
    {
      "id": "ec_17dcc651a87fd197d797ecbb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4973-95c0-74f3-bef5-f75464122b61.webp",
      "image_media": {
        "alt_text": "Volleyball court with net in front of apartment buildings",
        "public_id": "019d4973-95c0-74f3-bef5-f75464122b61",
        "storage_key": "property/6767906449166902/019d4973-95c0-74f3-bef5-f75464122b61.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation with a community volleyball court available for residents, set against a backdrop of our apartment buildings.",
      "link": "false",
      "alt_text": "Volleyball court with net in front of apartment buildings",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_VolleyballCourt.jpg"
    },
    {
      "id": "ec_c82f7613a04341b140901297",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d4973-97e5-70f5-9d05-bc19f02a8aa3.webp",
      "image_media": {
        "alt_text": "Walking path through a wooded area with dry grass and a pond.",
        "public_id": "019d4973-97e5-70f5-9d05-bc19f02a8aa3",
        "storage_key": "property/6767906449166902/019d4973-97e5-70f5-9d05-bc19f02a8aa3.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Community",
      "description": "Enjoy a leisurely stroll or bike ride on our scenic walking path, surrounded by mature trees and serene natural beauty. Perfect for unwinding.",
      "link": "false",
      "alt_text": "Walking path through a wooded area with dry grass and a pond.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RiverPointe_Sacramento_CA_Trail.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_48d02f0d-eeb7-4d67-9902-88aaabc67b1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "2001 Alta Arden Expy, Sacramento, CA 95825, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious Double Doubles, animal fries, and milkshakes. They highlight the fresh food, fast service, and friendly staff. They also like the good value and efficient drive-thru.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-2f27-7117-b52b-d02a6a74b2d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-2f27-7117-b52b-d02a6a74b2d7",
        "storage_key": "property/6767906449166902/019d08af-2f27-7117-b52b-d02a6a74b2d7.webp",
        "width": 1102,
        "height": 1280
      },
      "poi_business_url": "https://locations.in-n-out.com/276",
      "poi_directions_map_url": "https://maps.google.com/?cid=4866440018724358803&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "38.5980167",
      "poi_longitude": "-121.4194193",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-d9d8-757f-89cb-d209deabafac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-d9d8-757f-89cb-d209deabafac",
        "storage_key": "property/6767906449166902/019d08ae-d9d8-757f-89cb-d209deabafac.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ6ToLSPamoARk4rP3GkRiUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_5267652b-734c-4c82-85e3-cb6121fd29c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2101 Alta Arden Expy, Sacramento, CA 95825, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant offers delicious chicken sandwiches, salads, and shakes. They also highlight the friendly staff, fast service, and clean atmosphere.\n\nOther reviews mention orders can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-2e3e-73c0-9983-1fb4f7e3218c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-2e3e-73c0-9983-1fb4f7e3218c",
        "storage_key": "property/6767906449166902/019d08af-2e3e-73c0-9983-1fb4f7e3218c.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ca/arden-fair?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=15156801471129607094&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "38.5987882",
      "poi_longitude": "-121.4174906",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 916-922-2814",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-d9d8-757f-89cb-d209deabafac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-d9d8-757f-89cb-d209deabafac",
        "storage_key": "property/6767906449166902/019d08ae-d9d8-757f-89cb-d209deabafac.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Sz6ViPamoARtlvMQaLGV9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_7ed5d101-aba1-411d-aa11-5f37e65ab1ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Tower Café",
      "poi_type": "Restaurants",
      "poi_address": "1518 Broadway, Sacramento, CA 95818, USA",
      "poi_short_description": "Quirky cafe serving an eclectic array of grub, from classic breakfasts to Asian and Spanish mains.",
      "poi_long_description": "People say this restaurant serves delicious French toast, Thai steak and eggs, and salads. They highlight the large portions, diverse menu, and beautiful outdoor seating area with fountains and lush greenery. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-2e60-73b9-9b6e-f8868a9cf424.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-2e60-73b9-9b6e-f8868a9cf424",
        "storage_key": "property/6767906449166902/019d08af-2e60-73b9-9b6e-f8868a9cf424.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.towercafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17467647007537499128&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tower-caf",
      "poi_latitude": "38.5616745",
      "poi_longitude": "-121.4935217",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-441-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-d9d8-757f-89cb-d209deabafac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-d9d8-757f-89cb-d209deabafac",
        "storage_key": "property/6767906449166902/019d08ae-d9d8-757f-89cb-d209deabafac.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM4Wmdx7RmoAR-Asw4meMafI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_41051c89-7ff4-457b-a0a1-ed4f53d4800d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Drake's: The Barn",
      "poi_type": "Restaurants",
      "poi_address": "985 Riverfront St, West Sacramento, CA 95691, USA",
      "poi_short_description": "Outdoor gathering place with a beer garden, pizzeria & 3 stages hosting DJs & live music shows.",
      "poi_long_description": "People say this beer garden offers a great selection of beers, delicious pizzas, and burgers. They highlight the fun, energetic, and lively atmosphere, and the spacious outdoor seating with fire pits. They also like that it's dog-friendly and family-friendly.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-2f27-7117-b52b-ce9a72d5bae5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-2f27-7117-b52b-ce9a72d5bae5",
        "storage_key": "property/6767906449166902/019d08af-2f27-7117-b52b-ce9a72d5bae5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://drinkdrakes.com/places/the-barn/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4212264906490894141&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "drakes-the-barn",
      "poi_latitude": "38.574851",
      "poi_longitude": "-121.514729",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-74cf-71ca-8d5c-f7bcd90865bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-74cf-71ca-8d5c-f7bcd90865bf",
        "storage_key": "property/6767906449166902/019d08af-74cf-71ca-8d5c-f7bcd90865bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIzOrD0rRmoARPdc7a534dDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_d92453e3-f6ee-478a-abb2-4f401aed1261",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Urban Roots Brewery & Smokehouse",
      "poi_type": "Restaurants",
      "poi_address": "1322 V St, Sacramento, CA 95818, USA",
      "poi_short_description": "Stylish indoor-outdoor joint serving a wide variety of housemade beers alongside hearty BBQ fare.",
      "poi_long_description": "People say this brewpub serves delicious brisket, burnt ends, and BBQ turkey, and offers a variety of tasty sides. They highlight the generous portions, the self-serve BBQ sauce bar with three different sauces, and the friendly staff. They also like the fun, laid-back atmosphere, with both indoor and outdoor seating, and the extensive selection of craft beers and ciders.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-3472-72bf-9a60-ae23b5e3a76d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-3472-72bf-9a60-ae23b5e3a76d",
        "storage_key": "property/6767906449166902/019d08af-3472-72bf-9a60-ae23b5e3a76d.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.urbanrootsbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=322330605051558123&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-roots-brewery--smokehouse",
      "poi_latitude": "38.5655783",
      "poi_longitude": "-121.4941211",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-706-3741",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-74cf-71ca-8d5c-f7bcd90865bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-74cf-71ca-8d5c-f7bcd90865bf",
        "storage_key": "property/6767906449166902/019d08af-74cf-71ca-8d5c-f7bcd90865bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI6W_gh_RmoAR67hVPvoleQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "custom_44950230-a379-4124-9318-0edc5c330d37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Arden Fair",
      "poi_type": "Shopping & Retail",
      "poi_address": "1689 Arden Way, Sacramento, CA 95815, USA",
      "poi_short_description": "Bright, spacious mall featuring 150+ shops, a food court with fast food & full-service restaurants.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including clothing, shoes, and tech, as well as a large food court with diverse options. They also highlight the clean and well-maintained environment, and the presence of security.\n\nOther reviews mention parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-348a-71fe-9a13-ab067b18e623.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-348a-71fe-9a13-ab067b18e623",
        "storage_key": "property/6767906449166902/019d08af-348a-71fe-9a13-ab067b18e623.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ardenfair.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15499193860254925598&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arden-fair",
      "poi_latitude": "38.6011646",
      "poi_longitude": "-121.4276086",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-920-1167",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-da3b-71d2-aa7f-3385419dde5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-da3b-71d2-aa7f-3385419dde5a",
        "storage_key": "property/6767906449166902/019d08ae-da3b-71d2-aa7f-3385419dde5a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLwm9mh7amoARHgNpmbIyGNc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_992c90b6-38a6-4c13-87e6-8d6e9ca551bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "700 Ikea Ct, West Sacramento, CA 95605, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "People say this furniture store offers a wide variety of products, including beds, home decor, and Swedish meatballs. They also highlight the reasonable prices, clean and organized environment, and friendly staff.\n\nSome reviews mention the food court can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-3566-759b-b13e-157e01624815.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-3566-759b-b13e-157e01624815",
        "storage_key": "property/6767906449166902/019d08af-3566-759b-b13e-157e01624815.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/west-sacramento/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=west-sacramento",
      "poi_directions_map_url": "https://maps.google.com/?cid=1134161977023253649&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "38.58660769999999",
      "poi_longitude": "-121.5535253",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-da3b-71d2-aa7f-3385419dde5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-da3b-71d2-aa7f-3385419dde5a",
        "storage_key": "property/6767906449166902/019d08ae-da3b-71d2-aa7f-3385419dde5a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzyahGxSo6lQRkcw5Hk9avQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_c7b7d187-f8e4-41c9-b4d4-f9d9832b6a48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "5000 Folsom Blvd, Sacramento, CA 95819, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of unique, healthy, and organic foods, including fresh produce, snacks, and frozen meals. They highlight the reasonable prices, especially for flowers and cheese, and the friendly, helpful staff. They also like the well-stocked aisles and the clean, organized store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-3579-755a-bd40-c08ea1eb3251.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-3579-755a-bd40-c08ea1eb3251",
        "storage_key": "property/6767906449166902/019d08af-3579-755a-bd40-c08ea1eb3251.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/ca/sacramento/175/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5778462611759847179&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "38.5603947",
      "poi_longitude": "-121.4448167",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-456-1853",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-d9e3-7743-a241-7e32476bf27b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-d9e3-7743-a241-7e32476bf27b",
        "storage_key": "property/6767906449166902/019d08ae-d9e3-7743-a241-7e32476bf27b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvRh5PYDamoARC1fSOSE5MVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1ad6f3ed-6192-434c-a68e-f78abd30a72d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Sacramento Natural Foods Co-op",
      "poi_type": "Shopping & Retail",
      "poi_address": "2820 R St, Sacramento, CA 95816, USA",
      "poi_short_description": "Sustainably minded market for seasonal, organic produce as well as meats, fish & specialty foods.",
      "poi_long_description": "People say this grocery store offers a wide variety of natural, organic, and local products, including fresh produce, bulk items, and prepared foods. They highlight the clean, well-organized layout, and the convenient parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-39fa-73ab-bb8b-5ad807e0b558.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-39fa-73ab-bb8b-5ad807e0b558",
        "storage_key": "property/6767906449166902/019d08af-39fa-73ab-bb8b-5ad807e0b558.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sac.coop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15451927587609601651&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-natural-foods-co-op",
      "poi_latitude": "38.5645864",
      "poi_longitude": "-121.4725986",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-455-2667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-d9e3-7743-a241-7e32476bf27b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-d9e3-7743-a241-7e32476bf27b",
        "storage_key": "property/6767906449166902/019d08ae-d9e3-7743-a241-7e32476bf27b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXyB2vvLQmoARc2aH6kVGcNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1ced2087-1b9f-4398-801f-5a8b1478470c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "1814 19th St, Sacramento, CA 95811, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "People say this grocery store offers a wide variety of items, including fresh produce, prepared meals, and a deli section with sandwiches. They also highlight the friendly and helpful staff, the clean and well-maintained facility, and the convenient location with ample parking.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-3a83-764f-a17d-73a10e15ec94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-3a83-764f-a17d-73a10e15ec94",
        "storage_key": "property/6767906449166902/019d08af-3a83-764f-a17d-73a10e15ec94.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.safeway.com/safeway/ca/sacramento/1814-19th-st.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=9086144474484919629&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "38.5679278",
      "poi_longitude": "-121.4860899",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-492-9967",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-d9e3-7743-a241-7e32476bf27b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-d9e3-7743-a241-7e32476bf27b",
        "storage_key": "property/6767906449166902/019d08ae-d9e3-7743-a241-7e32476bf27b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb_q7ruDQmoARTU2NU0J4GH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c2de4198-ec73-4fdd-87e6-096c63042e89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "California State University, Sacramento",
      "poi_type": "Education",
      "poi_address": "6000 Jed Smith Dr, Sacramento, CA 95819, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-cca6-77b4-894c-4b19c8de97dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-cca6-77b4-894c-4b19c8de97dc",
        "storage_key": "property/6767906449166902/019d08ae-cca6-77b4-894c-4b19c8de97dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://csus.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8520208179546512258&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "california-state-university-sacramento",
      "poi_latitude": "38.560824",
      "poi_longitude": "-121.423993",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 916-278-6011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e2ab-7418-8585-92221847e0d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e2ab-7418-8585-92221847e0d2",
        "storage_key": "property/6767906449166902/019d08ae-e2ab-7418-8585-92221847e0d2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2_TGMY3amoARgls_gjLcPXY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4cd9ebaa-02fa-470f-ad09-066f04bacd24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Sacramento City College",
      "poi_type": "Education",
      "poi_address": "3835 Freeport Blvd, Sacramento, CA 95822, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-664d-732d-8849-473f6a6e1317.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-664d-732d-8849-473f6a6e1317",
        "storage_key": "property/6767906449166902/019d08ae-664d-732d-8849-473f6a6e1317.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.scc.losrios.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=530924599920790724&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-city-college",
      "poi_latitude": "38.5410812",
      "poi_longitude": "-121.4879724",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-558-2111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e2ab-7418-8585-92221847e0d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e2ab-7418-8585-92221847e0d2",
        "storage_key": "property/6767906449166902/019d08ae-e2ab-7418-8585-92221847e0d2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIaIDi03QmoARxIzLVBw5Xgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ccba2b38-1135-48ca-a85a-34386ce3b10c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Sacramento Central Public Library",
      "poi_type": "Education",
      "poi_address": "828 I St, Sacramento, CA 95814, USA",
      "poi_short_description": "Downtown institution offering books, computers, workshops and events for all ages. Books, videos and DVDs can also be borrowed via a library card. Spacious venue.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-3e4c-742c-9b8e-cfb1f3973104.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-3e4c-742c-9b8e-cfb1f3973104",
        "storage_key": "property/6767906449166902/019d08af-3e4c-742c-9b8e-cfb1f3973104.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.saclibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1674841591450889779&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-central-public-library",
      "poi_latitude": "38.5816683",
      "poi_longitude": "-121.4950844",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-264-2920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e2ab-7418-8585-92221847e0d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e2ab-7418-8585-92221847e0d2",
        "storage_key": "property/6767906449166902/019d08ae-e2ab-7418-8585-92221847e0d2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTfsMYyvRmoARM-56wY07Phc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_6afa15d0-b3cb-4d40-b5c0-a2075725504f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Golden 1 Center",
      "poi_type": "Entertainment",
      "poi_address": "500 David J Stern Walk, Sacramento, CA 95814, USA",
      "poi_short_description": "Modern venue built for basketball games, concerts and events, featuring a vegan food station.",
      "poi_long_description": "People say this arena offers a variety of drinks and snacks, and hosts concerts and basketball games. They highlight the comfortable seating, modern design, and excellent sound and video quality. They also like the friendly and helpful staff, and the convenient location with nearby parking and restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-6fa2-76ed-bf9f-a0fac6248e46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-6fa2-76ed-bf9f-a0fac6248e46",
        "storage_key": "property/6767906449166902/019d08ae-6fa2-76ed-bf9f-a0fac6248e46.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.golden1center.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10987748936193945510&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-1-center",
      "poi_latitude": "38.5802045",
      "poi_longitude": "-121.4996602",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 888-915-4647",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e218-719f-80b4-c68548931b3f",
        "storage_key": "property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvxlrBLxM6IARpi8EH3FTfJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_d7b09165-c122-4d73-88a1-5bf52c4bf96b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Sutter Health Park",
      "poi_type": "Entertainment",
      "poi_address": "400 Ballpark Dr, West Sacramento, CA 95691, USA",
      "poi_short_description": "Outdoor baseball field features regular sports games, concerts & events, with on-site concessions.",
      "poi_long_description": "People say this stadium offers a variety of seating options, including lawn seats, and has a fun atmosphere with fireworks and activities between innings. They highlight the friendly staff, clean facilities, and the opportunity to see both minor and major league baseball games. They also like the convenient parking and easy access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-4095-77df-bdb8-b1264ef55cc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-4095-77df-bdb8-b1264ef55cc6",
        "storage_key": "property/6767906449166902/019d08af-4095-77df-bdb8-b1264ef55cc6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sutterhealthpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2722204505153287407&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sutter-health-park",
      "poi_latitude": "38.5798114",
      "poi_longitude": "-121.5147519",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-376-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-79b3-7360-979d-08203ebf8b2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-79b3-7360-979d-08203ebf8b2b",
        "storage_key": "property/6767906449166902/019d08af-79b3-7360-979d-08203ebf8b2b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnalemcrWmoAR7zShF5M2xyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_c944ca63-12a2-4f57-ba6f-a0d2af0f2dff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Sacramento Zoo",
      "poi_type": "Entertainment",
      "poi_address": "3930 W Land Park Dr, Sacramento, CA 95822, USA",
      "poi_short_description": "Longtime, 14-acre animal park housing native & endangered species, plus a giraffe encounter exhibit.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including big cats, red pandas, and flamingos, and provides opportunities for giraffe feeding and a carousel ride. They also highlight the active animals, well-maintained habitats, and the friendly and knowledgeable staff.\n\nOther reviews mention the zoo can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-4257-745a-9c5d-409bc8b016c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-4257-745a-9c5d-409bc8b016c5",
        "storage_key": "property/6767906449166902/019d08af-4257-745a-9c5d-409bc8b016c5.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://saczoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6430915052866730629&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-zoo",
      "poi_latitude": "38.5392791",
      "poi_longitude": "-121.5040041",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-808-5888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e218-719f-80b4-c68548931b3f",
        "storage_key": "property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw0nl36XRmoARhXrVCiszP1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_47c4532f-f736-41a4-854b-9a31f1f48f55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "California State Railroad Museum",
      "poi_type": "Entertainment",
      "poi_address": "125 I St, Sacramento, CA 95814, USA",
      "poi_short_description": "Colorful museum documenting railroad history via vintage locomotives, exhibits & rides.",
      "poi_long_description": "People say this rail museum offers a collection of locomotives, train cars, and model trains, as well as interactive exhibits and a play area. They highlight the intimate setting, beautiful candlelight concerts, and the friendly and knowledgeable staff and volunteers. They also like the informative signs and the opportunity to explore inside some of the train cars. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-6de7-7512-8711-10708686c369.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-6de7-7512-8711-10708686c369",
        "storage_key": "property/6767906449166902/019d08ae-6de7-7512-8711-10708686c369.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.californiarailroad.museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13064911033240821480&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "california-state-railroad-museum",
      "poi_latitude": "38.5849368",
      "poi_longitude": "-121.5044161",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 916-323-9280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e2a8-77bc-90c9-4bab54b4b29a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e2a8-77bc-90c9-4bab54b4b29a",
        "storage_key": "property/6767906449166902/019d08ae-e2a8-77bc-90c9-4bab54b4b29a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJYxCsn83WmoAR6J5mJl3jT7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_cac2474e-d624-4d80-a1f5-83230b1e657f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "California State Capitol Museum",
      "poi_type": "Entertainment",
      "poi_address": "1315 10th St, Sacramento, CA 95814, USA",
      "poi_short_description": "Elegant, long-standing museum documenting the history of California via exhibits, artifacts & more.",
      "poi_long_description": "Visitors say this history museum offers free tours, a gift shop, and impressive architecture. They also highlight the knowledgeable and friendly tour guides, and the clean and well-maintained building and grounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-c63e-70ef-a795-0b5863571f6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-c63e-70ef-a795-0b5863571f6f",
        "storage_key": "property/6767906449166902/019d08ae-c63e-70ef-a795-0b5863571f6f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.capitolmuseum.ca.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=378875291323442389&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "california-state-capitol-museum",
      "poi_latitude": "38.5765882",
      "poi_longitude": "-121.4932368",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-324-0333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e2a8-77bc-90c9-4bab54b4b29a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e2a8-77bc-90c9-4bab54b4b29a",
        "storage_key": "property/6767906449166902/019d08ae-e2a8-77bc-90c9-4bab54b4b29a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJldtsqgTWmoAR1aSB8REJQgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_5ad32ba9-85c4-4219-8325-ed46c0a72a56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1020 7th St, Sacramento, CA 95814, USA",
      "poi_short_description": "Spacious fitness center with cardio machines, weight areas, basketball courts and a pool.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including cardio machines, free weights, and a basketball court, as well as amenities like a sauna, steam room, and hot tub. They also highlight the convenient parking, the welcoming and friendly staff, and the positive and uplifting atmosphere.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-4568-71aa-952f-10e80046afe7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-4568-71aa-952f-10e80046afe7",
        "storage_key": "property/6767906449166902/019d08af-4568-71aa-952f-10e80046afe7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/sacramento-ca/downtown-sacramento-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=4640322691779290524&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "38.5808218",
      "poi_longitude": "-121.4983842",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-658-1626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e218-719f-80b4-c68548931b3f",
        "storage_key": "property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmQN3eyzRmoARnGWwFue8ZUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d91bc6af-3419-4eac-bcdc-8a3a4ab40682",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1270 W Capitol Ave, Sacramento, CA 95691, USA",
      "poi_short_description": "Chain gym offering 24-hour access, tanning, and various cardio machines.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-4591-77ce-bbf7-ec821e238466.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-4591-77ce-bbf7-ec821e238466",
        "storage_key": "property/6767906449166902/019d08af-4591-77ce-bbf7-ec821e238466.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/west-sacramento-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=9304624826374633257&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.582102",
      "poi_longitude": "-121.5247628",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-516-1360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e218-719f-80b4-c68548931b3f",
        "storage_key": "property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpcry8OnXmoARKTdXSPuqIIE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bee9a959-2926-45da-ac37-9f584db39c91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "In-Shape Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3880 Innovator Dr, Sacramento, CA 95834, USA",
      "poi_short_description": "Family-friendly fitness center offering an indoor and outdoor pool plus a kids' zone and climbing wall.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, indoor and outdoor pools, and a kids' splash area.\n\nOther reviews mention the facilities can be poorly maintained and some machines can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-8959-7185-bebc-af1d5a753fac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-8959-7185-bebc-af1d5a753fac",
        "storage_key": "property/6767906449166902/019d08ae-8959-7185-bebc-af1d5a753fac.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.inshape.com/gyms/natomas?utm_source=G&utm_medium=Local&utm_campaign=Google-Local&utm_source=G&utm_medium=Local&utm_campaign=Google-Local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1974938444105111114&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-shape-fitness",
      "poi_latitude": "38.639569",
      "poi_longitude": "-121.5083534",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-239-4455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e218-719f-80b4-c68548931b3f",
        "storage_key": "property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZSiAMj_WmoARStYlHg1kaBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c623a949-8c3c-47dd-97d6-12f143edde44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "City Sports Club",
      "poi_type": "Health and Wellness",
      "poi_address": "3580 Crocker Dr, Sacramento, CA 95818, USA",
      "poi_short_description": "",
      "poi_long_description": "Some gym goers say this gym offers a wide variety of well-maintained machines, a clean facility, and friendly, helpful staff. \n\nOther reviews mention the gym can be crowded and membership cancellation can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-4921-7126-9333-5a689cc80251.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-4921-7126-9333-5a689cc80251",
        "storage_key": "property/6767906449166902/019d08af-4921-7126-9333-5a689cc80251.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.citysportsfitness.com/Pages/clubhome.aspx?clubid=1312&",
      "poi_directions_map_url": "https://maps.google.com/?cid=13663868868192490960&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-sports-club",
      "poi_latitude": "38.54227789999999",
      "poi_longitude": "-121.4838807",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-246-1636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e218-719f-80b4-c68548931b3f",
        "storage_key": "property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJffwWZuPRmoAR0NUhYlfQn70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ea3cd5c1-2535-4f49-a4b4-2292d99cf735",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Crunch Fitness - Market Square",
      "poi_type": "Health and Wellness",
      "poi_address": "1739 Arden Way, Sacramento, CA 95815, USA",
      "poi_short_description": "Membership-only gym at Market Square at Arden Fair offering group classes and personal trainers.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and classes. They also highlight the clean facilities, friendly staff, and welcoming atmosphere.\n\nOther reviews mention the membership can be difficult to cancel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-4ac9-760a-bbc5-bc3eac9c7291.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-4ac9-760a-bbc5-bc3eac9c7291",
        "storage_key": "property/6767906449166902/019d08af-4ac9-760a-bbc5-bc3eac9c7291.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.crunch.com/locations/marketsquare",
      "poi_directions_map_url": "https://maps.google.com/?cid=17728157417301185125&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---market-square",
      "poi_latitude": "38.5994681",
      "poi_longitude": "-121.4232353",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-913-2260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e218-719f-80b4-c68548931b3f",
        "storage_key": "property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKZ8uG_3bmoARZZJxRD4RB_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9b11bb9b-dc36-4d93-a3b7-3bda04bb393e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Sacramento Central YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "2021 W St, Sacramento, CA 95818, USA",
      "poi_short_description": "Community fitness center with a swimming pool and classes, plus programs for children.",
      "poi_long_description": "People say this gym offers a variety of workout equipment, group exercise classes, and a large, heated indoor pool. They also highlight the friendly and helpful staff, the welcoming and inclusive atmosphere, and the clean facilities.\n\nOther reviews mention the facilities can be outdated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-4bff-7722-84cd-251445edf2c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-4bff-7722-84cd-251445edf2c5",
        "storage_key": "property/6767906449166902/019d08af-4bff-7722-84cd-251445edf2c5.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "http://www.ymcasuperiorcal.org/sacramentoymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=5417990014250751205&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-central-ymca",
      "poi_latitude": "38.5623639",
      "poi_longitude": "-121.4855257",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-452-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e218-719f-80b4-c68548931b3f",
        "storage_key": "property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTUhHi-PQmoAR5ZQHVDaRMEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fe33e7c5-5187-4a4b-8fd8-23b1d66ff032",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Fitness System",
      "poi_type": "Health and Wellness",
      "poi_address": "2531 Evergreen Ave, West Sacramento, CA 95691, USA",
      "poi_short_description": "Clean fitness center featuring cardio machines, weights and weightlifting equipment.",
      "poi_long_description": "People say this gym has a wide variety of equipment and is open 24 hours. They also highlight the friendly and helpful staff who go the extra mile to assist customers.\n\nSome reviews mention the account cancellation process can be inconvenient.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-4fc8-74d2-ba31-7eaa5494e68d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-4fc8-74d2-ba31-7eaa5494e68d",
        "storage_key": "property/6767906449166902/019d08af-4fc8-74d2-ba31-7eaa5494e68d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://fitnesssystemhealthclubs.com/locations/gym-in-west-sacramento-ca?utm_source=google&utm_medium=gmb&utm_campaign=gmb_listings&utm_content=west_sacramento",
      "poi_directions_map_url": "https://maps.google.com/?cid=11564238311494912985&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fitness-system",
      "poi_latitude": "38.5766337",
      "poi_longitude": "-121.5453795",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-371-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e218-719f-80b4-c68548931b3f",
        "storage_key": "property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV5phVwTUmoAR2QuebnltfKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_53f99e2c-e2ff-4bc3-8554-3667cd900101",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "3591 N Freeway Blvd, Sacramento, CA 95834, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-51da-777c-932a-bf8542653209.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-51da-777c-932a-bf8542653209",
        "storage_key": "property/6767906449166902/019d08af-51da-777c-932a-bf8542653209.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/sacramento-ca-189",
      "poi_directions_map_url": "https://maps.google.com/?cid=3579456942113057783&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "38.6410428",
      "poi_longitude": "-121.4996954",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-285-6450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e218-719f-80b4-c68548931b3f",
        "storage_key": "property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkbl0OjbWmoAR92t0wx_JrDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_352b1aa0-15bf-4a9c-8239-bb92d168bdaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "UC Davis Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4301 X St, Sacramento, CA 95817, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-7d5c-728c-b5c1-47a6f3204bd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-7d5c-728c-b5c1-47a6f3204bd8",
        "storage_key": "property/6767906449166902/019d08ae-7d5c-728c-b5c1-47a6f3204bd8.webp",
        "width": 500,
        "height": 330
      },
      "poi_business_url": "https://health.ucdavis.edu/medicalcenter/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8899362877471555770&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uc-davis-medical-center",
      "poi_latitude": "38.5547656",
      "poi_longitude": "-121.4552827",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 916-734-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e958-739c-88d4-2478d14db45d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e958-739c-88d4-2478d14db45d",
        "storage_key": "property/6767906449166902/019d08ae-e958-739c-88d4-2478d14db45d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJA4rq2nzQmoARuoD93mLjgHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_6b6e32fd-41a0-4cc4-913e-bdf89fb536f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Mercy General Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4001 J St, Sacramento, CA 95819, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-53fc-71ee-8c2a-52890ad95703.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-53fc-71ee-8c2a-52890ad95703",
        "storage_key": "property/6767906449166902/019d08af-53fc-71ee-8c2a-52890ad95703.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.dignityhealth.org/mercy-general-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=7368210846584852456&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-general-hospital",
      "poi_latitude": "38.5706208",
      "poi_longitude": "-121.4528939",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-453-4545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e958-739c-88d4-2478d14db45d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e958-739c-88d4-2478d14db45d",
        "storage_key": "property/6767906449166902/019d08ae-e958-739c-88d4-2478d14db45d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJcQNtDZvQmoAR6M_e_LkkQWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e0d71378-bab3-4294-8ceb-c23666850d23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Discovery Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Sacramento, CA 95833, USA",
      "poi_short_description": "302-acre park featuring a 32-mile bike trail, ball fields, picnic sites, fishing & boat launches.",
      "poi_long_description": "People say this park offers a boat launch, fishing, and picnic areas with barbecue grills and shade. They also highlight the spacious layout, the American River bike trail, and the beautiful views of the river confluence.\n\nSome reviews mention the park can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-67aa-7706-911b-0a4549ecbe8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-67aa-7706-911b-0a4549ecbe8b",
        "storage_key": "property/6767906449166902/019d08ae-67aa-7706-911b-0a4549ecbe8b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://regionalparks.saccounty.net/Parks/Pages/DiscoveryPark.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6608359273538838528&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "discovery-park",
      "poi_latitude": "38.6057626",
      "poi_longitude": "-121.50348",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 916-875-6961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e40f-75a9-8d80-e758dc62f8c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e40f-75a9-8d80-e758dc62f8c3",
        "storage_key": "property/6767906449166902/019d08ae-e40f-75a9-8d80-e758dc62f8c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqjbDmoARAOBwJ7-btVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_648e145e-f01b-49c2-860d-5de51fc34f3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "McKinley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "601 Alhambra Blvd, Sacramento, CA 95816, USA",
      "poi_short_description": "Relaxing preserve featuring a rose garden, seasonal pool, playgrounds, tennis courts & trails.",
      "poi_long_description": "Visitors say this park offers a relaxing atmosphere with a beautiful rose garden, perfect for long walks or jogs, and a pond where you can feed the ducks. They also highlight the well-maintained park, spacious for picnics, and fun for kids with a large playground and a nearby public pool.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-564b-70e5-8275-41083203919b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-564b-70e5-8275-41083203919b",
        "storage_key": "property/6767906449166902/019d08af-564b-70e5-8275-41083203919b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofsacramento.org/ParksandRec/Parks/Park-Directory/Central-City/McKinley-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9817515343663866372&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mckinley-park",
      "poi_latitude": "38.5768935",
      "poi_longitude": "-121.4630764",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-808-6060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e40f-75a9-8d80-e758dc62f8c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e40f-75a9-8d80-e758dc62f8c3",
        "storage_key": "property/6767906449166902/019d08ae-e40f-75a9-8d80-e758dc62f8c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb6sj4JfQmoARBCIIjDDSPog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7ae80cac-84ca-422e-981b-29113181ca94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "California State Capitol Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1300 L St, Sacramento, CA 95814, USA",
      "poi_short_description": "Scenic city green space with monuments, memorials, flower gardens & walking paths.",
      "poi_long_description": "People say this park offers beautiful gardens, exotic trees, and historic monuments, including a rose garden and memorials to veterans and firefighters. They highlight the peaceful and relaxing vibe, and the well-maintained grounds with clear signage. They also like that the park is dog-friendly and provides opportunities for learning about botany and history. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-5660-73a2-bd85-78a4d163ed90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-5660-73a2-bd85-78a4d163ed90",
        "storage_key": "property/6767906449166902/019d08af-5660-73a2-bd85-78a4d163ed90.webp",
        "width": 640,
        "height": 853
      },
      "poi_business_url": "https://capitolmuseum.ca.gov/learn/about-the-capitol/capitol-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5243745298811035407&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "california-state-capitol-park",
      "poi_latitude": "38.5759282",
      "poi_longitude": "-121.4907022",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-324-0333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e40f-75a9-8d80-e758dc62f8c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e40f-75a9-8d80-e758dc62f8c3",
        "storage_key": "property/6767906449166902/019d08ae-e40f-75a9-8d80-e758dc62f8c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJuVIWBdjQmoARD59BFJGGxUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2dd33d08-9c4b-4fe2-a0ba-366aa389f2a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "State Capitol Park World Peace Rose Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1317 15th St, Sacramento, CA 95814, USA",
      "poi_short_description": "Peace-themed Victorian style rose garden within a park, with a fountain & pavilion.",
      "poi_long_description": "Visitors say this rose garden offers a tranquil experience with hundreds of varieties of roses in bloom, as well as trees from all over the world. They also highlight the well-maintained park, peaceful atmosphere, and educational value of the different rose species.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-57e4-746f-a5be-c195ced3a84f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-57e4-746f-a5be-c195ced3a84f",
        "storage_key": "property/6767906449166902/019d08af-57e4-746f-a5be-c195ced3a84f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://worldpeacerosegardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1381262157938595809&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "state-capitol-park-world-peace-rose-garden",
      "poi_latitude": "38.575501",
      "poi_longitude": "-121.4883327",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-381-5433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e40f-75a9-8d80-e758dc62f8c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e40f-75a9-8d80-e758dc62f8c3",
        "storage_key": "property/6767906449166902/019d08ae-e40f-75a9-8d80-e758dc62f8c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJL_Yds9nQmoAR4ZeeSZ06KxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_3324f0c6-1117-4f10-976e-8a5f1ec2d76b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Sutter's Fort State Historic Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2701 L St, Sacramento, CA 95816, USA",
      "poi_short_description": "The oldest restored fort in the U.S. depicts pioneer life via costumed docents, programs & exhibits.",
      "poi_long_description": "People say this state park offers a fascinating glimpse into California's early history with well-preserved buildings, historical artifacts, and informative signs. They highlight the affordable admission fee, the self-guided tour that allows visitors to explore at their own pace, and the pleasant outdoor setting with a pond and park. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-5b14-76ac-b7c8-c824ac7f0c8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-5b14-76ac-b7c8-c824ac7f0c8c",
        "storage_key": "property/6767906449166902/019d08af-5b14-76ac-b7c8-c824ac7f0c8c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.parks.ca.gov/?page_id=485",
      "poi_directions_map_url": "https://maps.google.com/?cid=17280317289212065050&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sutters-fort-state-historic-park",
      "poi_latitude": "38.5723389",
      "poi_longitude": "-121.4712056",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-445-4422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e40f-75a9-8d80-e758dc62f8c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e40f-75a9-8d80-e758dc62f8c3",
        "storage_key": "property/6767906449166902/019d08ae-e40f-75a9-8d80-e758dc62f8c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJzSCPgOrQmoARGrWG_QQF0O8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_38076708-e9a9-4228-8959-310f6d6c3c90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Sacramento Valley Station (WB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sacramento, CA 95814, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-5d65-74ea-b779-554e4ea4a1e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-5d65-74ea-b779-554e4ea4a1e6",
        "storage_key": "property/6767906449166902/019d08af-5d65-74ea-b779-554e4ea4a1e6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6346517780329793861&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-valley-station-wb",
      "poi_latitude": "38.584627",
      "poi_longitude": "-121.500439",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e218-719f-80b4-c68548931b3f",
        "storage_key": "property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJncYA5dLWmoARRQlCwUtcE1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_c911de10-abd0-4423-931d-17f5df6a93de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Arden/Del Paso Station (EB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sacramento, CA 95815, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-b211-77f6-8462-e4dc71d61fe7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-b211-77f6-8462-e4dc71d61fe7",
        "storage_key": "property/6767906449166902/019d08ae-b211-77f6-8462-e4dc71d61fe7.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=567876029887657118&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ardendel-paso-station-eb",
      "poi_latitude": "38.606207",
      "poi_longitude": "-121.456274",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e218-719f-80b4-c68548931b3f",
        "storage_key": "property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd59FpVrXmoARnrTpjT2A4Qc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_1e11c522-c947-449f-965b-1f7725b99133",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "7th & Capitol",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sacramento, CA 95814, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-5fba-765d-b51a-0b5fa61871fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-5fba-765d-b51a-0b5fa61871fe",
        "storage_key": "property/6767906449166902/019d08af-5fba-765d-b51a-0b5fa61871fe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5048847390555747041&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "7th--capitol",
      "poi_latitude": "38.5783062",
      "poi_longitude": "-121.4989023",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e218-719f-80b4-c68548931b3f",
        "storage_key": "property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDTq-mS7RmoAR4bI7p_MbEUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_941d0654-3974-4687-9f09-cacb9de149f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "16th Street Station (EB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sacramento, CA 95811, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-6005-777e-9eba-d9fc49f76820.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-6005-777e-9eba-d9fc49f76820",
        "storage_key": "property/6767906449166902/019d08af-6005-777e-9eba-d9fc49f76820.webp",
        "width": 1280,
        "height": 806
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4554807020176890849&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "16th-street-station-eb",
      "poi_latitude": "38.5697554",
      "poi_longitude": "-121.4891647",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e218-719f-80b4-c68548931b3f",
        "storage_key": "property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJowcyqN_QmoAR4VsZOtrsNT8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_b4914f2a-3bd9-41fb-97e3-17966d96808a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "St. Rose of Lima Park ( 9th & K )",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sacramento, CA 95814, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-644b-768f-80fe-57dd3cce345d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-644b-768f-80fe-57dd3cce345d",
        "storage_key": "property/6767906449166902/019d08af-644b-768f-80fe-57dd3cce345d.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3232408438487941295&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "st-rose-of-lima-park--9th--k-",
      "poi_latitude": "38.5795637",
      "poi_longitude": "-121.495492",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e218-719f-80b4-c68548931b3f",
        "storage_key": "property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO9nzYCnRmoARr4AMSVnS2yw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_20e48501-5e7f-480c-a74e-ea08ebe99cf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Sacramento City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "915 I St, Sacramento, CA 95814, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-6388-7430-8672-90bfee7b3bea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-6388-7430-8672-90bfee7b3bea",
        "storage_key": "property/6767906449166902/019d08af-6388-7430-8672-90bfee7b3bea.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://www.cityofsacramento.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5261544109164931557&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-city-hall",
      "poi_latitude": "38.5823421",
      "poi_longitude": "-121.4933431",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-264-5011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-ee7b-71ee-a39a-c71ed2fee398.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-ee7b-71ee-a39a-c71ed2fee398",
        "storage_key": "property/6767906449166902/019d08ae-ee7b-71ee-a39a-c71ed2fee398.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY9NSRSrRmoAR5SnTjH3CBEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_db139652-22a1-49d4-af85-f1dcba88caf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Blue Diamond Growers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1802 C St, Sacramento, CA 95811, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-66c6-73f7-9f8b-fb874c68a881.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-66c6-73f7-9f8b-fb874c68a881",
        "storage_key": "property/6767906449166902/019d08af-66c6-73f7-9f8b-fb874c68a881.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bluediamondgrowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16247972805344263985&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blue-diamond-growers",
      "poi_latitude": "38.5857959",
      "poi_longitude": "-121.4810041",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-442-0771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e218-719f-80b4-c68548931b3f",
        "storage_key": "property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE7CwctLQmoARMX_AVi5lfOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_3f4f8010-b798-4165-98e8-b0fcc995f59d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "City of West Sacramento City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1110 W Capitol Ave, West Sacramento, CA 95691, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-66c6-73f7-9f8b-f7250552132b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-66c6-73f7-9f8b-f7250552132b",
        "storage_key": "property/6767906449166902/019d08af-66c6-73f7-9f8b-f7250552132b.webp",
        "width": 1280,
        "height": 808
      },
      "poi_business_url": "http://www.cityofwestsacramento.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5233966858684488344&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-west-sacramento-city-hall",
      "poi_latitude": "38.58203210000001",
      "poi_longitude": "-121.5234091",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-617-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-ee7b-71ee-a39a-c71ed2fee398.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-ee7b-71ee-a39a-c71ed2fee398",
        "storage_key": "property/6767906449166902/019d08ae-ee7b-71ee-a39a-c71ed2fee398.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcUyoorHWmoARmFoOkiDJokg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_2c32f555-57a9-4c0b-915e-18a5f161f22f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Resources Building - State of California",
      "poi_type": "Major Employers & Offices",
      "poi_address": "715 P St, Sacramento, CA 95814, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-6b47-7488-8d81-0896a5a1acc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-6b47-7488-8d81-0896a5a1acc1",
        "storage_key": "property/6767906449166902/019d08af-6b47-7488-8d81-0896a5a1acc1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://resources.ca.gov/About-Us/our-new-headquarters",
      "poi_directions_map_url": "https://maps.google.com/?cid=13310981311370573820&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "resources-building---state-of-california",
      "poi_latitude": "38.5752007",
      "poi_longitude": "-121.4993404",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-367-5690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e218-719f-80b4-c68548931b3f",
        "storage_key": "property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH9oPNi_RmoAR_DcbZPoaurg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_331a3b43-d418-4397-9d9e-c76ae745922d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "poi_name": "Centene Campus Natomas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4201 E Commerce Way, Sacramento, CA 95834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08af-6da7-738a-b552-d6d5c63b2f14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-6da7-738a-b552-d6d5c63b2f14",
        "storage_key": "property/6767906449166902/019d08af-6da7-738a-b552-d6d5c63b2f14.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.centene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9616052681257976114&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "centene-campus-natomas",
      "poi_latitude": "38.6466286",
      "poi_longitude": "-121.5240407",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 314-725-4477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e218-719f-80b4-c68548931b3f",
        "storage_key": "property/6767906449166902/019d08ae-e218-719f-80b4-c68548931b3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaddcK4jXmoARMgHTL_cUc4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_a67e6a8d-41da-49ff-920f-3cbb069e319e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_5d1ae649-5278-467a-9cfc-d94234b7e6b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_be1a843e-d6d2-4403-ab75-30183bd1914f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_1280464c-4add-4850-bb39-9cbe38706b2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_8de431c4-a042-4a2e-b50f-574909112f71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_146019f3-1aef-4552-a033-323c8011fe5e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_8f98d645-b8ef-4935-9e1e-23f461ce745f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "day": "SUN",
      "open_time": "10:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_67e02a9b-9bf8-43e7-9d9b-0d647706df36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "rating": "5.0",
      "name": "Yocasta Carolina Zeledon Raudes",
      "text": "This is such a beautiful place to live, there are many trees and they always have clean, if you have any problems with the apartment they solve quickly, I like it, and it is 100% recommended.",
      "date": "2026-03-02",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_85c348e3-cbcd-4802-9602-16e82809989d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d2c3f-9d47-707b-bea4-272d01dad11a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c3f-9d47-707b-bea4-272d01dad11a",
        "storage_key": "property/6767906449166902/019d2c3f-9d47-707b-bea4-272d01dad11a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "River Pointe Apartments  - 1 Bedroom 1 Bath 655 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=TjF2PuRFWng"
    },
    {
      "id": "custom_a772a4aa-aa23-43e5-9605-ba977f5e5179",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d2c3f-b4d8-7148-b532-f78faa435f8e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c3f-b4d8-7148-b532-f78faa435f8e",
        "storage_key": "property/6767906449166902/019d2c3f-b4d8-7148-b532-f78faa435f8e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "River Pointe Apartments - 2 Bedroom 1 Bath 765 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=3LfPXixJ7Y4"
    },
    {
      "id": "custom_91797750-0192-43d3-8d08-1efe3ed3f2d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d2c3f-cb44-7424-94b6-f1728ff2e98e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c3f-cb44-7424-94b6-f1728ff2e98e",
        "storage_key": "property/6767906449166902/019d2c3f-cb44-7424-94b6-f1728ff2e98e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "River Pointe Apartments - 2 Bedroom 2 Bath 875 Sq. Ft. Model",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=9BrGAtHJKes"
    },
    {
      "id": "custom_983a8a87-88a0-4638-8ab3-d90c09fb152d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d2c3f-e1db-762f-afd0-6accd529f7b2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c3f-e1db-762f-afd0-6accd529f7b2",
        "storage_key": "property/6767906449166902/019d2c3f-e1db-762f-afd0-6accd529f7b2.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "River Pointe Apartments  - 2 Bedroom 2 Bath 955 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=yYZ4cSpypME"
    },
    {
      "id": "custom_daa9a287-6a0e-4720-99c5-fa47bf4a8fb1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166902/019d2c3f-fe3c-727c-9c38-78d01a021f32.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c3f-fe3c-727c-9c38-78d01a021f32",
        "storage_key": "property/6767906449166902/019d2c3f-fe3c-727c-9c38-78d01a021f32.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "River Pointe Apartments - Pool & Spa",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=nRAUBmoAkb8"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db1b7-a8de-75d2-ae29-e3705bd37d74",
      "lead_source": "LANDING_PAGE",
      "name": "River Pointe Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "generator",
      "page_item_url": "apartments-with-swimming-pool-sacramento-river-pointe",
      "search_query": "apartments with swimming pool Sacramento",
      "category": "Amenity",
      "h1_title": "Sacramento Apartments with Swimming Pools",
      "h2_subtitle": "Discover River Pointe's stunning swimming pools in Sacramento. Dive into luxury at our Sacramento apartment community featuring outdoor pools.",
      "page_copy": "Looking for apartments with swimming pool in Sacramento? River Pointe offers an exceptional living experience with not just one, but three outdoor swimming pools and three spas. Nestled in the serene North Sacramento neighborhood, our community is designed for relaxation and enjoyment. Spend your weekends lounging by the pool or taking a refreshing swim in one of our pristine pools. \n\nRiver Pointe's prime location in Sacramento County ensures easy access to shopping, dining, and entertainment venues. Our on-site fitness center complements the outdoor amenities, allowing residents to maintain a healthy lifestyle. With convenient reserved parking and a plethora of amenities, our community is the perfect place to call home. Explore the vibrant local scene and immerse yourself in the comfort and luxury that River Pointe offers.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sacramento Apartments with Swimming Pools",
      "seo_description": "Experience 3 swimming pools and more at River Pointe. Enjoy premier Sacramento living with great amenities and style.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "generator",
      "page_item_url": "fitness-center-apartment-north-sacramento-river-pointe",
      "search_query": "fitness center apartment North Sacramento",
      "category": "Amenity",
      "h1_title": "North Sacramento Apartments with Fitness Center",
      "h2_subtitle": "Explore River Pointe's top-notch fitness center in North Sacramento. Our state-of-the-art facility keeps you active and engaged.",
      "page_copy": "For those searching for a fitness center apartment in North Sacramento, River Pointe is the ideal choice. Our fully-equipped fitness center provides residents with everything they need to maintain a healthy lifestyle right at home. Whether you prefer strength training or cardio sessions, our gym accommodates all workout routines.\n\nRiver Pointe is more than just a place to live—it's a lifestyle destination. Alongside our fitness facilities, enjoy access to three outdoor swimming pools and relaxing spas. Located in a tranquil area of North Sacramento, River Pointe offers reserved parking and a welcoming community atmosphere. Discover the convenience and comfort of our Sacramento apartment living and embrace an active, engaged lifestyle with us.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "North Sacramento Apartments with Fitness Center",
      "seo_description": "Enjoy a premium fitness center at River Pointe in North Sacramento. Make this vibrant community your new home with amazing amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "generator",
      "page_item_url": "reserved-parking-apartments-95833-river-pointe",
      "search_query": "reserved parking apartments 95833",
      "category": "Amenity",
      "h1_title": "Apartments with Reserved Parking in 95833",
      "h2_subtitle": "Enjoy the convenience of reserved parking at River Pointe. Our 95833 community offers exclusive parking in North Sacramento.",
      "page_copy": "Searching for reserved parking apartments in the 95833 area? River Pointe provides a premier living experience with the added convenience of reserved parking. Located in the heart of Sacramento's Oak Harbour Drive, our community offers a relaxed lifestyle with easy access to all essentials.\n\nBeyond parking, residents can enjoy a variety of amenities such as a fitness center and three outdoor swimming pools. North Sacramento's serene environment combined with River Pointe's luxurious offerings makes it a sought-after place to call home. Embrace our vibrant community where convenience meets comfort. With everything you need right at your doorstep, River Pointe is the perfect choice for modern living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Reserved Parking in 95833",
      "seo_description": "Discover River Pointe's reserved parking in 95833. Enjoy premium apartment living with great amenities and convenient parking options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "generator",
      "page_item_url": "apartment-with-spa-sacramento-county-river-pointe",
      "search_query": "apartment with spa Sacramento County",
      "category": "Amenity",
      "h1_title": "Sacramento County Apartments with Spa",
      "h2_subtitle": "Unwind at River Pointe's luxurious spas in Sacramento County. Experience relaxation at its finest in our vibrant community.",
      "page_copy": "If you're searching for an apartment with spa in Sacramento County, look no further than River Pointe. Our community features three rejuvenating spas, providing an oasis of relaxation for residents seeking tranquility. Set in the charming neighborhood of North Sacramento, River Pointe combines modern living with serene surroundings.\n\nIn addition to our inviting spas, residents can enjoy numerous amenities including three outdoor swimming pools and a well-equipped fitness center. Conveniently located, River Pointe offers easy access to local dining, shopping, and entertainment options. With its blend of luxury and comfort, our Sacramento County community provides an ideal living environment where unwinding after a long day is effortless.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sacramento County Apartments with Spa",
      "seo_description": "Relax in style at River Pointe's luxurious spas in Sacramento County. Discover premium apartment living with exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "generator",
      "page_item_url": "sacramento-apartments-with-pool-and-spa-river-pointe",
      "search_query": "Sacramento apartments with pool and spa",
      "category": "Amenity",
      "h1_title": "Sacramento Apartments with Pool & Spa",
      "h2_subtitle": "Discover River Pointe's impressive pools and spas in Sacramento. Luxurious amenities await in our welcoming community.",
      "page_copy": "Experience luxurious living at River Pointe, where Sacramento apartments with pool and spa create a perfect retreat. Our community boasts three stunning outdoor swimming pools and serene spas, offering a refreshing escape in the heart of Sacramento County. Perfect for relaxation or social gatherings, our amenities elevate your lifestyle.\n\nNestled in North Sacramento, River Pointe not only offers aquatic comforts but also features a modern fitness center and reserved parking. The convenient location provides easy access to the vibrant local culture, dining, and entertainment. Make the most of what Sacramento has to offer while enjoying the comfort and style at River Pointe, where home is an everyday getaway.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sacramento Apartments with Pool & Spa",
      "seo_description": "Enjoy River Pointe's pools and spas in Sacramento. Dive into relaxation with premium amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-sacramento-ca-river-pointe",
      "search_query": "one bedroom apartments sacramento ca",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Sacramento, CA",
      "h2_subtitle": "Explore comfortable one-bedroom apartments at River Pointe, Sacramento, CA. Experience convenience and style in a prime location.",
      "page_copy": "Discover spacious one bedroom apartments in Sacramento, CA, at River Pointe, where modern design meets everyday comfort. Our stylishly appointed apartments provide the perfect blend of functionality and luxury, making them ideal for singles or couples looking to enjoy Sacramento's vibrant lifestyle.\n\nLocated in North Sacramento, River Pointe offers a host of community amenities including a state-of-the-art fitness center, three outdoor swimming pools, and rejuvenating spas. With reserved parking available, convenience is at every corner. Enjoy quick access to local shopping, dining, and entertainment, making River Pointe a sought-after destination in Sacramento County. Choose River Pointe for a comprehensively enriching living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Sacramento, CA",
      "seo_description": "Find spacious one bedroom apartments at River Pointe, Sacramento, CA. Enjoy modern amenities and convenient living in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "generator",
      "page_item_url": "two-bedroom-floor-plans-north-sacramento-river-pointe",
      "search_query": "two bedroom floor plans north sacramento",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Floor Plans in North Sacramento",
      "h2_subtitle": "Discover spacious two bedroom floor plans at River Pointe in North Sacramento. Experience versatility and comfort in our vibrant community.",
      "page_copy": "Explore the ideal living space with our two bedroom floor plans in North Sacramento at River Pointe. Designed with both comfort and functionality in mind, these layouts provide ample room for families, roommates, or those needing extra space.\n\nIn addition to the thoughtful design of our apartments, River Pointe offers a variety of community amenities like three outdoor swimming pools, relaxing spas, and a fully-equipped fitness center. Situated in a desirable neighborhood, residents enjoy easy access to local dining, shopping, and entertainment venues. River Pointe's combination of modern interiors and convenient location makes it a prime choice for those seeking two bedroom living in North Sacramento.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Floor Plans in North Sacramento",
      "seo_description": "Explore spacious two bedroom floor plans at River Pointe, North Sacramento. Enjoy modern amenities and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "generator",
      "page_item_url": "apartments-near-california-state-university-sacramento-river-pointe",
      "search_query": "apartments near California State University Sacramento",
      "category": "School",
      "h1_title": "Apartments Near California State University",
      "h2_subtitle": "Find convenient apartments near California State University, Sacramento at River Pointe. Enjoy modern amenities and a short commute.",
      "page_copy": "Located just a short drive from California State University, Sacramento, River Pointe offers ideal apartment living for students, faculty, and staff. Our community provides a perfect blend of comfort, convenience, and an active lifestyle with amenities like a modern fitness center and several outdoor swimming pools and spas.\n\nSet in North Sacramento, River Pointe residents can enjoy the local vibe with close access to shopping, dining, and entertainment options. Plus, with reserved parking, you'll appreciate the ease of commuting. Make River Pointe your home and relish in the balance of academic life and relaxation, with everything you need just moments away from California State University.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near California State University",
      "seo_description": "Discover River Pointe, ideal apartments near California State University, Sacramento. Enjoy modern amenities and a convenient commute.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "generator",
      "page_item_url": "apartments-near-sacramento-city-college-north-sacramento-river-pointe",
      "search_query": "apartments near Sacramento City College North Sacramento",
      "category": "School",
      "h1_title": "Apartments Near Sacramento City College",
      "h2_subtitle": "Discover ideal apartments near Sacramento City College in North Sacramento. River Pointe offers comfort and convenience just minutes from campus.",
      "page_copy": "River Pointe is the perfect spot for those seeking apartments near Sacramento City College in North Sacramento. Our community features spacious floor plans designed for students and professionals alike, offering easy access to campus and the vibrant local community.\n\nEnjoy amenities that make life convenient and enjoyable, such as a well-equipped fitness center, multiple outdoor swimming pools, and relaxing spas. Our prime location in North Sacramento ensures that you're close to shopping, dining, and entertainment options, making River Pointe a top choice for those connected to Sacramento City College. With reserved parking and a friendly community atmosphere, River Pointe is more than just a place to live; it's a lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sacramento City College",
      "seo_description": "Find River Pointe apartments near Sacramento City College in North Sacramento. Enjoy modern amenities and easy campus access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "generator",
      "page_item_url": "apartments-near-uc-davis-medical-center-sacramento-river-pointe",
      "search_query": "apartments near UC Davis Medical Center Sacramento",
      "category": "Hospital",
      "h1_title": "Apartments Near UC Davis Medical Center",
      "h2_subtitle": "Explore ideal living near UC Davis Medical Center in Sacramento. River Pointe offers comfort, convenience, and modern amenities for professionals and students.",
      "page_copy": "River Pointe presents a perfect choice for those searching for apartments near UC Davis Medical Center in Sacramento. Our community features spacious and well-designed units, making it an excellent home base for medical professionals, students, and families.\n\nSituated in North Sacramento, River Pointe provides easy access to UC Davis Medical Center, while also being close to various shopping and dining options. With three outdoor swimming pools, relaxing spas, and a fitness center, residents enjoy both relaxation and an active lifestyle. The combination of convenient location and modern amenities makes River Pointe a popular option for anyone connected to UC Davis Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near UC Davis Medical Center",
      "seo_description": "Find comfort and convenience at River Pointe, ideal apartments near UC Davis Medical Center in Sacramento with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "generator",
      "page_item_url": "apartment-rentals-by-mercy-general-hospital-north-sacramento-river-pointe",
      "search_query": "apartment rentals by Mercy General Hospital North Sacramento",
      "category": "Hospital",
      "h1_title": "Apartment Rentals Near Mercy General Hospital",
      "h2_subtitle": "Discover apartment rentals near Mercy General Hospital in North Sacramento. River Pointe offers a blend of convenience and comfort for healthcare professionals.",
      "page_copy": "For those seeking apartment rentals near Mercy General Hospital in North Sacramento, River Pointe provides an ideal solution. Our community is designed with the needs of healthcare professionals and hospital staff in mind, offering easy access to your workplace.\n\nAt River Pointe, residents enjoy more than just proximity to Mercy General Hospital. With amenities such as a fitness center, three outdoor swimming pools, and dedicated parking, we ensure a comfortable and stress-free living experience. Located in the vibrant North Sacramento area, you'll also find yourself close to an array of dining, shopping, and entertainment options, making it an excellent choice for those with a busy lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Rentals Near Mercy General Hospital",
      "seo_description": "Explore River Pointe, offering convenient apartment rentals near Mercy General Hospital in North Sacramento with numerous amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "generator",
      "page_item_url": "apartments-near-discovery-park-sacramento-river-pointe",
      "search_query": "apartments near Discovery Park Sacramento",
      "category": "Park",
      "h1_title": "Apartments Near Discovery Park",
      "h2_subtitle": "Experience the charm of living near Discovery Park in Sacramento. River Pointe combines scenic beauty with modern living amenities in North Sacramento.",
      "page_copy": "Nestled in the vibrant North Sacramento area, River Pointe offers apartments near Discovery Park that blend modern living with nature's beauty. Ideal for those who enjoy outdoor activities, our community places you just moments from the vast greenery and recreation options of Discovery Park.\n\nResidents at River Pointe benefit from exceptional amenities, including a fitness center and three outdoor swimming pools. Whether you're an outdoor enthusiast or prefer to unwind in a spa, our community caters to diverse lifestyles. With easy access to both urban conveniences and natural escapes, River Pointe is the perfect home for enjoying all Sacramento has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Discovery Park",
      "seo_description": "Discover River Pointe for ideal living near Discovery Park in Sacramento, offering modern amenities and easy access to green spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "generator",
      "page_item_url": "mckinley-park-nearby-apartments-north-sacramento-river-pointe",
      "search_query": "McKinley Park nearby apartments North Sacramento",
      "category": "Park",
      "h1_title": "Nearby Apartments to McKinley Park",
      "h2_subtitle": "Explore the joy of living near McKinley Park in North Sacramento. River Pointe offers convenient, modern living with excellent amenities for all residents.",
      "page_copy": "If you're looking for McKinley Park nearby apartments in North Sacramento, River Pointe is an excellent choice. Our community offers modern apartments that cater to the lifestyles of all residents, from families to professionals.\n\nSituated in the bustling area of North Sacramento, River Pointe provides easy access to McKinley Park's beautiful trails and community spaces. Enjoy amenities such as a fitness center, three swimming pools, and relaxing spas. The combination of a strategic location and contemporary living spaces makes River Pointe a favored option among those who appreciate both nature and convenience. Make River Pointe your home and enjoy the vibrant local scene.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to McKinley Park",
      "seo_description": "Discover River Pointe, the ideal choice for nearby apartments to McKinley Park in North Sacramento, with modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "generator",
      "page_item_url": "california-state-capitol-park-close-apartments-95833-river-pointe",
      "search_query": "California State Capitol Park close apartments 95833",
      "category": "Park",
      "h1_title": "Close Apartments to Capitol Park 95833",
      "h2_subtitle": "Find great apartments close to California State Capitol Park. River Pointe offers ideal living in the 95833 area, combining comfort and convenience.",
      "page_copy": "For those searching for California State Capitol Park close apartments in the 95833 area, River Pointe is a standout choice. Situated in North Sacramento, our community provides convenient access to the vibrant attractions and historical significance of Capitol Park.\n\nRiver Pointe offers more than just proximity; we deliver a lifestyle enriched with amenities like a fitness center, three swimming pools, and dedicated parking. Our apartments are tailored for comfort and ease, making daily life both practical and enjoyable. Choose River Pointe and experience the perfect blend of modern living and cultural accessibility in Sacramento.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Close Apartments to Capitol Park 95833",
      "seo_description": "Explore River Pointe for apartments close to California State Capitol Park in the 95833 area, offering modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "generator",
      "page_item_url": "apartments-close-to-sutters-fort-historic-park-sacramento-county-river-pointe",
      "search_query": "apartments close to Sutter's Fort Historic Park Sacramento County",
      "category": "Park",
      "h1_title": "Apartments Near Sutter's Fort Historic Park",
      "h2_subtitle": "Discover convenience with apartments near Sutter's Fort Historic Park. River Pointe offers prime living in Sacramento County with modern amenities.",
      "page_copy": "Searching for apartments close to Sutter's Fort Historic Park in Sacramento County? Look no further than River Pointe. Positioned in North Sacramento, our community offers a blend of historical charm and modern convenience just a short drive from this iconic landmark.\n\nResidents at River Pointe enjoy an array of amenities including a well-equipped fitness center, multiple swimming pools, and relaxing spas. Our strategic location provides easy access to cultural and historical sites like Sutter's Fort, while also offering the peace of suburban living. Experience the dynamic lifestyle that River Pointe provides, balancing comfort and accessibility.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sutter's Fort Historic Park",
      "seo_description": "River Pointe offers convenient living near Sutter's Fort Historic Park in Sacramento County, with modern amenities and easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "generator",
      "page_item_url": "apartments-near-sacramento-valley-station-wb-river-pointe",
      "search_query": "apartments near Sacramento Valley Station WB",
      "category": "Transit",
      "h1_title": "Apartments Near Sacramento Valley Station WB",
      "h2_subtitle": "Find ideal apartments near Sacramento Valley Station WB. River Pointe offers modern living with quick transit access in North Sacramento.",
      "page_copy": "River Pointe is the ideal choice for those seeking apartments near Sacramento Valley Station WB. Located in North Sacramento, our community offers residents ease of commuting and a contemporary living experience just a short distance from the station.\n\nOur apartments boast amenities that cater to every lifestyle, including a state-of-the-art fitness center, three refreshing swimming pools, and relaxing spas. With reserved parking and a convenient location, River Pointe ensures seamless connectivity to public transport as well as local shopping and dining. Choose River Pointe for a harmonious blend of convenience and comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sacramento Valley Station WB",
      "seo_description": "Discover River Pointe for convenient living near Sacramento Valley Station WB, offering modern amenities in North Sacramento.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "generator",
      "page_item_url": "river-pointe-housing-close-to-arden-del-paso-station-eb-sacramento",
      "search_query": "River Pointe housing close to Arden/Del Paso Station EB",
      "category": "Transit",
      "h1_title": "River Pointe Housing Near Arden/Del Paso EB",
      "h2_subtitle": "Explore River Pointe housing near Arden/Del Paso Station EB, offering a convenient location in North Sacramento with modern amenities.",
      "page_copy": "River Pointe presents an exceptional living experience for those seeking housing close to the Arden/Del Paso Station EB. Nestled in North Sacramento, our community ensures easy access to efficient public transit alongside the comfort of modern living.\n\nResidents benefit from extraordinary amenities, including a fitness center fully equipped to meet your wellness goals, and three outdoor swimming pools with accompanying spas for ultimate leisure. Reserved parking offers peace of mind, while the proximity to Arden/Del Paso Station facilitates a smooth commute. Discover the ease and vibrant community living offered at River Pointe.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "River Pointe Housing Near Arden/Del Paso EB",
      "seo_description": "Discover River Pointe, conveniently located near Arden/Del Paso Station EB in North Sacramento, offering modern living and accessible transit.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "generator",
      "page_item_url": "north-sacramento-living-by-7th-capitol-transit-river-pointe",
      "search_query": "North Sacramento living by 7th & Capitol transit",
      "category": "Transit",
      "h1_title": "North Sacramento Living by 7th & Capitol",
      "h2_subtitle": "Experience North Sacramento living by 7th & Capitol transit at River Pointe, where comfort meets convenience.",
      "page_copy": "Discover the best of North Sacramento living at River Pointe, conveniently located near the 7th & Capitol transit lines. Our community offers a unique blend of suburban tranquility and urban accessibility, making it the perfect choice for commuters and those who love city action.\n\nRiver Pointe residents enjoy a range of upscale amenities, including a modern fitness center, inviting swimming pools, and soothing spas, ideal for unwinding after a long day. With reserved parking and quick access to 7th & Capitol transit, living at River Pointe means you can navigate the city with ease. Embrace a lifestyle where convenience and comfort converge.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "North Sacramento Living by 7th & Capitol",
      "seo_description": "River Pointe offers North Sacramento living near 7th & Capitol transit, featuring modern amenities and convenient access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "generator",
      "page_item_url": "sacramento-county-apartments-by-16th-street-station-eb-river-pointe",
      "search_query": "Sacramento County apartments by 16th Street Station EB",
      "category": "Transit",
      "h1_title": "Sacramento County Apartments by 16th Street EB",
      "h2_subtitle": "Discover Sacramento County apartments near 16th Street Station EB. River Pointe offers luxurious amenities just a transit stop away.",
      "page_copy": "Welcome to River Pointe, where finding Sacramento County apartments near 16th Street Station EB has never been easier. Our community is conveniently situated to provide seamless access to the bustling heart of Sacramento, making it an ideal choice for commuters and those seeking a vibrant urban lifestyle.\n\nAt River Pointe, residents enjoy outstanding amenities designed for comfort and convenience, including a well-equipped fitness center, three sparkling outdoor pools, and serene spas. With reserved parking and closeness to the 16th Street Station EB, daily commutes are streamlined. Choose River Pointe for exceptional apartment living in Sacramento County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sacramento County Apartments by 16th Street EB",
      "seo_description": "River Pointe offers convenient Sacramento County apartments near 16th Street Station EB, featuring modern activities and easy transit access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166902",
      "source": "generator",
      "page_item_url": "st-rose-of-lima-park-apartments-near-9th-k-transit-river-pointe",
      "search_query": "St. Rose of Lima Park apartments near 9th & K transit",
      "category": "Transit",
      "h1_title": "St. Rose of Lima Park Apts Near 9th & K",
      "h2_subtitle": "Explore apartment living near St. Rose of Lima Park and 9th & K transit. River Pointe offers unmatched convenience and luxury.",
      "page_copy": "Discover the convenience of living at River Pointe, a prime choice among St. Rose of Lima Park apartments near the 9th & K transit hub. Our location offers residents effortless access to Sacramento's vibrant city life and excellent transit connections.\n\nRiver Pointe combines a serene community setting with top-tier amenities, including a comprehensive fitness center, three outdoor swimming pools, and relaxing spas. With reserved parking and a short distance from the 9th & K transit stops, commuting is a breeze. Experience the perfect balance of comfort and accessibility at River Pointe.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "St. Rose of Lima Park Apts Near 9th & K",
      "seo_description": "River Pointe offers modern living close to St. Rose of Lima Park and 9th & K transit, featuring luxury amenities and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5080"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372413321"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TLR64ZDJ"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321266756"
    },
    {
      "ID": "custom_company_license_number",
      "type": "STRING",
      "value": "#01090130"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-691-8247 "
    }
  ],
  "custom_qb_id": "5080",
  "custom_repli_id": "18372413321",
  "custom_google_gtm_id": "GTM-TLR64ZDJ",
  "custom_hubspot_company_id": "17321266756",
  "custom_company_license_number": "#01090130",
  "custom_ppc_tracking_phone_number": "844-691-8247 "
};

export const generatedAt = '2026-09-23T19:55:12.223Z';
